import React, { useState, useRef, useEffect, useLayoutEffect, useCallback, useMemo, Key } from 'react';
// @ts-expect-error
import View from '@arcgis/core/views/MapView';
// @ts-expect-error
import Measurement from '@arcgis/core/widgets/Measurement';
// @ts-expect-error
import WebTileLayer from '@arcgis/core/layers/WebTileLayer';
// @ts-expect-error
import GeoJSONLayer from '@arcgis/core/layers/GeoJSONLayer';
import JSZip from 'jszip';
// @ts-expect-error
import Point from '@arcgis/core/geometry/Point';
// @ts-expect-error
import Graphic from '@arcgis/core/Graphic';
import { loadProjectOperator, projectGeometry } from 'esri/projectGeometry';
import { useAppSelector } from 'hooks/appSelector';
import { MapView } from 'components/Map';
import NavBar from 'components/NavBar';
import ToolBar from 'components/Toolbar';
import SearchContainer from 'components/SearchContainer';
import UserContainer from 'components/UserContainer';
import Charting from 'containers/Charting';
import Attributes from 'components/Attributes';
import Loader from 'components/Loader';
import SurveyLayerPanel from 'components/SurveyLayerPanel';
import { SurveyLayerEntry, buildSurveyLabel } from 'components/SurveyLayerPanel/types';
import { useSurveyManagerActions } from 'actions/surveymanager';
import { SearchDetails } from 'models/SearchDetails';
import { RgbaColor } from 'react-colorful';
import { blue, orange, purple, yellow, red, black, WFS_LAYER_PALETTE } from 'utils/colors';
import { resolveGeoJsonEndPointUrl } from 'utils/layerEndPointUrl';
import { toSurveyManagerSlug } from 'utils/surveyManagerSlug';
import { SymbologyModelRecord } from 'models/SymbologyModel';
import { SymbologyModel } from 'models/SymbologyModel';
import { LayerAttributeStyle } from 'models/LayerAttributeStyle';
import { LayerRuleStypeElement, LayerRuleStyleRecord } from 'models/LayerRuleStyle';
import './style.scss';
// @ts-expect-error
import esriConfig from '@arcgis/core/config';
import { appInsights } from '../../index';
import { MAX_ZOOM } from 'esri/map';
import { useNavigate, useLocation } from 'react-router-dom';
import { getDashboardHomePath, isDashboardPath, isInspectionsToolkitPath } from 'config/loginPortals';
import { saveAs } from 'file-saver';
import { writeShapefile } from '../../lib/shpwrite/shapefileWriter';
// @ts-expect-error
import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
// @ts-expect-error
import { openDB, IDBPDatabase } from 'idb';
// @ts-expect-error
import WMTSLayer from '@arcgis/core/layers/WMTSLayer';
// @ts-expect-error
import * as geometryEngine from '@arcgis/core/geometry/geometryEngine';
import dropPinIconUrl from 'assets/images/survey-drop-pin-icon.png';
import { isSurveyPlayerTenant } from 'utils/tenant';
import {
  applyTravelDirectionArrowColor,
  buildSurveyTravelDirectionSymbol,
  orientLayerFeaturesToCourseBearing,
  shouldShowSurveyTravelDirectionArrows,
} from 'utils/surveyTravelDirection';
import {
  resolveSurveyWfsPointSizePx,
  roundSurveyWfsPointZoom,
  SURVEY_WFS_POINT_DEFAULT_BASE_PX,
} from 'utils/surveyWfsPointSize';
// @ts-expect-error
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
import { ImageViewerProvider, useImageViewers, OpenViewerParams } from 'components/ImageViewer/ImageViewerContext';
import {
  MAX_SIMULTANEOUS_IMAGES,
  notifyImageViewerCapacityLimit,
} from 'components/ImageViewer/imageViewerLimits';
import MultiImageViewer, {
  IMAGE_VIEWER_WORKSPACE_SPLIT_EVENT,
  type ImageViewerWorkspaceSplitDetail,
} from 'components/ImageViewer/MultiImageViewer';
import type { LayerFeature, LayerFeatureGeometry, SyncMode, PanoramaState } from 'components/ImageViewer/types';
import PlaybackGrid, {
  type PlaybackDownloadAllControls,
} from 'components/Playback/PlaybackGrid';
import LayerSelectModal from 'components/Playback/LayerSelectModal';
import type { PlaybackLayer } from 'components/Playback/types';
import { useActiveDefectLayersOnMap } from './hooks/useActiveDefectLayersOnMap';
import { useDefectOverviewGridOnMap } from './hooks/useDefectOverviewGridOnMap';
import { useDefectOverlayVectorsOnMap } from './hooks/useDefectOverlayVectorsOnMap';
import {
  getSdmPanToDefectGoToOptions,
  isExtentCenterOffScreen,
  resolveDefectExtentCenter,
  SDM_PAN_TO_DEFECT_EXTENT_EVENT,
} from 'domain/surveyDataManager/map/sdmPanToDefectExtent';
import {
  registerSurveyCoverageClickConfig,
  resolveClickHandlerId,
  unregisterSurveyCoverageClickConfig,
  updatesAttributesModal,
  type LayerClickConfigRegistry,
} from './mapClick';
import {
  flyToSurveyHighlightIfOutOfView,
  flyToSurveyLayerIfOutOfView,
  stopMapViewAnimation,
  SURVEY_MAP_FLY_TO_DURATION_MS,
  SURVEY_MAP_FLY_TO_EASING,
} from './surveyLayerViewport';
import {
  SURVEY_IMAGE_DRAG_MIME,
  resolveMaxDropDistanceMeters,
  isWfsImageLayer,
  resolvePlaybackPinPoint,
  resolvePlaybackWfsLayerSelection,
  toCssRgbaColor,
  type PlaybackPinPoint,
} from './surveyPlaybackHelpers';
import {
  resolvePegmanDropGeometryCache,
  resolvePegmanDropSelection,
  resolvePegmanNearestImageForPlayback,
} from './surveyPegmanDropFlow';
import { resolvePlaySurveyClick } from './surveyPlayButtonFlow';
import {
  buildSurveyWmtsLayerKey,
  isSurveyWmtsLayer as isPanelSurveyWmtsLayer,
  resolveLayerOrthoScope,
  shouldLinkWmtsLayers,
} from './surveyWmtsLinking';
import {
  DROP_PIN_RECENTER_DURATION_MS,
  isMapPointOutsidePaddedExtent,
  preloadDropPinImage,
  runDropPinFallOverlay,
  waitForDropMapSettled,
  waitForPlaybackSplitReady,
} from './dropPinFallOverlay';
import {
  completeDropPinFallToMapPin,
  restoreDropPinSourceButton,
} from './dropPinLandingSequence';
import {
  isMapPointOnHighlightedSurvey,
  isSurveyImageDragMimePresent,
} from './surveyDropTarget';
import type { DropPinLandingApi } from 'components/SurveyLayerPanel';
import {
  shouldReuseSurveyDragHit,
  type ScreenHitSample,
} from './surveyImageDragHitTest';
import {
  normalizeImageIndex,
  buildPlaybackTimelineSyncValues,
  resolvePlaybackStartPosition,
  resolvePlaybackSyncModeChange,
} from 'utils/syncIndex';
import {
  fromActiveDefectMapLayerId,
  isActiveDefectMapLayerId,
  normalizeActiveDefectMapLayerId,
  toActiveDefectMapLayerId,
} from 'domain/surveyDataManager/map/activeLayerMapId';
import {
  bringSurveyLayerForward,
  isSurveyWmtsLayer,
  placeLayerBelowSdmOverlays,
  stripSdmOverviewMapLayerSuffix,
} from 'domain/surveyDataManager/map/layerStackOrder';
import { isDefectOverlayLayerKind } from 'domain/surveyDataManager/defectOverlays/overlayKinds';
import {
  buildSdmFeatureInfoDetails,
  isCrackmapWfsFeature,
  shouldCloseAttributesForActiveLayer,
  type SdmFeatureInfoPresentation,
} from 'domain/surveyDataManager/map/sdmFeatureInfo';
import {
  selectActiveDefectLayers,
  type ActiveDefectLayerId,
} from 'state/surveyDataManager';
import { store } from 'state/store';
import type { ContextMenuLayerNode, RefreshableGeoJsonLayer } from 'types/layerRefresh';
import {
  buildNetworkGeoLayerUrl,
  createGeoJsonBlobUrl,
  enrichContextMenuNode,
  getLoadingKeysForRefresh,
  normalizeFavouritesContextNode,
  resolveContextMenuLayerUrl,
  resolveSelectedLayerKey,
  scheduleBlobUrlRevoke,
  shouldUseRefreshDataFetch,
} from 'utils/layerRefreshUrl';
import { fetchGeoJsonWithRefresh } from 'utils/fetchGeoJsonWithRefresh';
import {
  applySearchResultHighlights,
  resolveAssetLayerSearchSync,
  resolveSearchResultsHighlightAction,
} from './dashboardSearchBehavior';
import {
  searchCurrentLayerAssetLabels,
  type QueryableAssetLayer,
} from 'utils/assetLayerSearch';
import { searchActions } from 'actions/search';
import { applyGeoJsonLayerRenderer } from 'utils/geoJsonLayerRenderer';
import { applySurveyCoverageLayerRenderer } from 'utils/surveyCoverageLayerRenderer';
import {
  formatSurveyRefreshError,
  resolveSurveyCoverageRefreshLayerUrl,
} from 'utils/surveyCoverageRefresh';
import { enrichFeaturesForShapefileExport } from 'utils/shapefileExportEnrichment';
import {
  isNetworkSectionsGeoLayer,
  type MapFeatureLike,
} from 'utils/networkShapefileExport';
import {
  type LayerExportProgress,
  buildExportProgressUpdate,
} from 'utils/layerExportProgress';
import { buildLegendLayerExportName } from 'utils/legendExportNaming';
import {
  isExportAbortError,
  throwIfExportCancelled,
} from 'utils/shapefileExportCancellation';
import { applyCheckedNodesStateUpdate } from 'utils/checkedNodesState';
import { extractSurveyYear } from 'utils/extractSurveyYear';
import type { LegendCheckedNode } from './dashboardSearchBehavior';

type UnknownRecord = Record<string, unknown>;
type MutableUnknownRecord = Record<string, unknown>;
type DashboardSymbologyModel = Partial<SymbologyModel> & MutableUnknownRecord;
type DashboardSymbologyModelRecord = Record<string, DashboardSymbologyModel>;
type ArcGisHandleLike = { remove: () => void };
type ArcGisQuery = Record<string, unknown>;

interface ArcGisUniqueValueInfoLike {
  value?: unknown;
  symbol?: MutableUnknownRecord;
}

interface ArcGisRendererLike extends MutableUnknownRecord {
  symbol?: MutableUnknownRecord;
  defaultSymbol?: MutableUnknownRecord;
  uniqueValueInfos?: ArcGisUniqueValueInfoLike[];
  clone?: () => ArcGisRendererLike;
}

interface ArcGisGraphicLike {
  geometry: Geometry;
  symbol?: MutableUnknownRecord;
  attributes?: UnknownRecord;
  properties?: UnknownRecord;
  graphic?: ArcGisGraphicLike;
  layer: ArcGisLayerLike;
}

interface ArcGisQueryResultLike {
  features: ArcGisGraphicLike[];
}

interface ArcGisLayerViewLike {
  highlight: (target: unknown) => ArcGisHandleLike;
  updating?: boolean;
  when?: () => Promise<unknown>;
  watch?: (
    propertyName: string,
    callback: (value: boolean) => void,
  ) => ArcGisHandleLike;
}

interface ArcGisLayerCollectionLike {
  items: ArcGisLayerLike[];
  length: number;
  toArray: () => ArcGisLayerLike[];
  forEach: (callback: (layer: ArcGisLayerLike) => void) => void;
  find: (callback: (layer: ArcGisLayerLike) => boolean) => ArcGisLayerLike | undefined;
  some: (callback: (layer: ArcGisLayerLike) => boolean) => boolean;
  getItemAt: (index: number) => ArcGisLayerLike | undefined;
  add: (layer: ArcGisLayerLike, index?: number) => void;
  addMany: (layers: ArcGisLayerLike[]) => void;
  remove: (layer: ArcGisLayerLike) => void;
  removeMany: (layers: ArcGisLayerLike[]) => void;
  removeAt: (index: number) => ArcGisLayerLike | undefined;
  reorder: (layer: ArcGisLayerLike, index: number) => void;
  findLayerById?: (id: string) => ArcGisLayerLike | undefined;
}

interface ArcGisLayerLike extends MutableUnknownRecord {
  id?: string;
  name?: string;
  title?: string;
  type?: string;
  url?: string;
  endpoint?: string;
  visible?: boolean;
  checked?: boolean;
  fullExtent?: unknown;
  geometryType?: string;
  renderer?: ArcGisRendererLike;
  featureReduction?: MutableUnknownRecord | null;
  tileInfo?: { lods?: UnknownRecord[] };
  refreshTimestamp?: number | null;
  refresh?: () => void;
  load?: () => Promise<unknown>;
  createQuery?: () => MutableUnknownRecord;
  queryFeatures?: (query: ArcGisQuery) => Promise<ArcGisQueryResultLike>;
  when?: (callback?: () => void) => Promise<unknown>;
  on?: (eventName: string, callback: (...args: unknown[]) => void) => ArcGisHandleLike;
}

interface LayerListNode {
  key: string;
  name?: string;
  title?: string;
  category?: string;
  endPoint?: string;
  endpoint?: string;
  type?: string;
  children?: LayerListNode[];
}

function toQueryableAssetLayer(
  layer: ArcGisLayerLike | null | undefined,
): QueryableAssetLayer | null {
  if (!layer) {
    return null;
  }

  return {
    load: layer.load
      ? async (): Promise<void> => {
          await layer.load?.();
        }
      : undefined,
    fields: Array.isArray(layer.fields)
      ? (layer.fields as ReadonlyArray<{ readonly name?: string }>)
      : undefined,
    queryFeatures: layer.queryFeatures
      ? async (query) => {
          const result = await layer.queryFeatures?.(query);
          return {
            features: result?.features?.map((feature) => ({
              geometry: feature.geometry,
              attributes: feature.attributes ?? {},
            })),
          };
        }
      : undefined,
  };
}

function toLayerListNode(
  node: LegendCheckedNode | null,
): LayerListNode | null {
  if (!node?.key) {
    return null;
  }

  return {
    key: node.key,
    title: node.title,
    category: node.category,
    endPoint: node.endPoint,
  };
}

interface SurveyPanelInput extends UnknownRecord {
  survey_type?: string;
  survey_slug?: string;
}

interface SurveyShapefileSummary {
  category?: string;
  slug?: string;
  filePath?: string;
}

function toSlugFormat(str: string): string {
  return toSurveyManagerSlug(str);
}

function findSurveyLayer(slug: string, surveyLayers: readonly string[]): string {
  const match = [...surveyLayers]
    .sort((a, b) => b.length - a.length)
    .find((layer) => slug.includes(toSlugFormat(layer)));
  return match ?? '';
}

function readOptionalNumericAttribute(
  attributes: UnknownRecord | undefined,
  key: string,
): number | null {
  const raw = attributes?.[key];
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? Math.trunc(parsed) : null;
}

interface VisualisationRuleInfo extends UnknownRecord {
  name: string;
  label: string;
  dataType?: string;
  value?: string | number;
  style: UnknownRecord;
}

interface ArcGisMapLike {
  layers: ArcGisLayerCollectionLike;
  add: (layer: ArcGisLayerLike) => void;
  remove: (layer: ArcGisLayerLike) => void;
  reorder: (layer: ArcGisLayerLike, index: number) => void;
  findLayerById?: (id: string) => ArcGisLayerLike | undefined;
}

interface ArcGisViewLike {
  map: ArcGisMapLike;
  graphics: { removeAll: () => void };
  padding?: unknown;
  width: number;
  height: number;
  zoom: number;
  resolution?: number;
  updating?: boolean;
  constraints: {
    lods?: readonly UnknownRecord[];
    minZoom?: number;
    maxZoom?: number;
    snapToZoom?: boolean;
  };
  goTo: (target: unknown, options?: UnknownRecord) => Promise<unknown> | void;
  when: (callback?: () => void) => Promise<unknown>;
  whenLayerView: (layer: ArcGisLayerLike) => Promise<ArcGisLayerViewLike>;
  hitTest: (screenPoint: UnknownRecord) => Promise<{ results: ArcGisGraphicLike[] }>;
  on: (eventName: string, callback: (event: UnknownRecord) => void) => ArcGisHandleLike;
  watch: (propertyName: string, callback: () => void) => ArcGisHandleLike;
  requestRender?: () => void;
}

interface Geometry {
  type: 'point' | 'polyline' | 'polygon' | 'Point' | 'LineString' | 'Polygon';
  coordinates?: number[] | number[][] | number[][][];
  x?: number;
  y?: number;
  longitude?: number;
  latitude?: number;
  paths?: number[][][];
  rings?: number[][][];
  spatialReference?: { wkid?: number; latestWkid?: number };
  getPoint?: (pathIndex: number, pointIndex: number) => { latitude?: number; longitude?: number; x?: number; y?: number };
  extent?: {
    xmin: number;
    ymin: number;
    xmax: number;
    ymax: number;
    spatialReference?: { wkid?: number };
  };
}

interface Feature {
  geometry: Geometry;
  attributes?: UnknownRecord;
  properties?: UnknownRecord;
}

interface QueryResult {
  features: Feature[];
}

interface LegendDBSchema {
  layersStyle: {
    key: string;
    value: DashboardSymbologyModelRecord;
  };
  layerRulesStyle: {
    key: string;
    value: { layerRules: LayerRuleStypeElement[]; url: string; expression: string };
  };
}

const BASE_API_URL = `${process.env.REACT_APP_API_URL}/api`;

let clickEvent: ArcGisHandleLike | null = null;
let highlight: ArcGisHandleLike | null = null;
let dbPromise: Promise<IDBPDatabase<LegendDBSchema>>;

const NETWORK_LAYER_VIEW_SETTLE_TIMEOUT_MS = 8000;

async function waitForLayerViewSettled(
  layerView: ArcGisLayerViewLike,
  timeoutMs = NETWORK_LAYER_VIEW_SETTLE_TIMEOUT_MS,
): Promise<void> {
  if (typeof layerView.when === 'function') {
    await layerView.when();
  }
  if (!layerView.updating) {
    return;
  }

  await Promise.race([
    reactiveUtils.whenOnce(() => !layerView.updating),
    new Promise<void>((resolve) => {
      window.setTimeout(resolve, timeoutMs);
    }),
  ]);
}

async function waitForSurveyLayerViewReady(
  mapView: ArcGisViewLike,
  layer: ArcGisLayerLike,
): Promise<void> {
  if (typeof layer.when === 'function') {
    await layer.when();
  }
  const layerView = await mapView.whenLayerView(layer);
  await waitForLayerViewSettled(layerView);
  await waitForMapViewSettled(mapView);
}

/** Wait until MapView tiles/layers finish updating */
async function waitForMapViewSettled(
  mapView: ArcGisViewLike,
  timeoutMs = NETWORK_LAYER_VIEW_SETTLE_TIMEOUT_MS,
): Promise<void> {
  await new Promise<void>((resolve) => {
    window.requestAnimationFrame(() => resolve());
  });
  if (!mapView.updating) {
    return;
  }

  await Promise.race([
    reactiveUtils.whenOnce(() => !mapView.updating),
    new Promise<void>((resolve) => {
      window.setTimeout(resolve, timeoutMs);
    }),
  ]);
}

/** Wait until network GeoJSON has painted so the landing overlay does not clear into a blank map. */
async function waitForNetworkLayerPaintReady(
  mapView: ArcGisViewLike,
  layer: ArcGisLayerLike,
): Promise<void> {
  if (typeof layer.when === 'function') {
    await layer.when();
  }
  const layerView = await mapView.whenLayerView(layer);
  await waitForLayerViewSettled(layerView);
}

function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAppSelector((state) => state.user);
  const [view, setView] = useState<View | null>(null);
  const networkAttachedViewRef = useRef<View | null>(null);
  useActiveDefectLayersOnMap(view);
  const defectOverviewLoading = useDefectOverviewGridOnMap(view);
  const defectOverlayLoading = useDefectOverlayVectorsOnMap(view);
  const activeDefectLayers = useAppSelector(selectActiveDefectLayers);
  const activeDefectLayerIdsRef = useRef(activeDefectLayers.map((layer) => layer.id));
  activeDefectLayerIdsRef.current = activeDefectLayers.map((layer) => layer.id);
  const activeDefectLayersRef = useRef(activeDefectLayers);
  activeDefectLayersRef.current = activeDefectLayers;
  const measurementWidget = useRef<Measurement | null>(null);
  const [currentLayer, setCurrentLayer] = useState('StadiaMaps');
  const [baseLayer, setBaseLayer] = useState<ArcGisLayerLike | null>(null);
  const [requestMade, setRequestMade] = useState(0);
  const [layerData, setLayerData] = useState<Record<string, ArcGisLayerLike>>({});
  const [attributesModalData, setAttributesModalData] = useState<({ name?: string } & UnknownRecord) | null>(null);
  const [attributesSourceActiveLayerId, setAttributesSourceActiveLayerId] =
    useState<ActiveDefectLayerId | null>(null);
  const [modalState, setModalState] = useState<Record<string, boolean>>({ 'Major asset group overview': false, Basemaps: true, Attributes: false, Legend: true, });
  const [actionsState, setActionsState] = useState<Record<string, boolean>>({ Measure: false, Legend: true, Basemaps: true, });
  const [searchContent, setSearchContent] = useState<SearchDetails>({ selectedItem: undefined, type: 'network', selectedKey: 'network-layer', selectedLabel: 'Network', selectedCategory: 'Network', });
  const [selectedNode, setSelectedNode] = useState<LayerListNode | null>(null);
  const [layersStyle, setLayersStyle] = useState<DashboardSymbologyModelRecord>({});
  const [layerRulesStyles, setLayerRulesStyles] = useState<LayerRuleStyleRecord>({});
  const showModal = (title: string) => setModalState((prevState) => ({ ...prevState, [title]: true }));

  const onCloseModal = (title: string) => {
    setModalState((prevState) => ({ ...prevState, [title]: false }));
    if (title === 'Inspections Toolkit' && isInspectionsToolkitPath(location.pathname)) {
      navigate(getDashboardHomePath(location.pathname));
    }
  };
  const [primaryIsExpanded, setPrimaryIsExpanded] = useState<boolean>(false);
  const [secondaryIsExpanded, setSecondaryIsExpanded] = useState<boolean | null>(null);
  const [zoomStackIsAllowed, setZoomStackIsAllowed] = useState<boolean>(false);
  const [isClusteringEnabled, setIsClusteringEnabled] = useState<boolean>(user?.clustering || true,);
  const [checkedNodesState, setCheckedNodesState] = useState<LayerListNode[]>([]);
  const [layerRefreshLoading, setLayerRefreshLoading] = useState<
    Record<string, { isLoading: boolean; hasError: boolean; errorMessage?: string }>
  >({
    'network-layer': { isLoading: true, hasError: false },
  });
  const [hasNetworkLoadedOnce, setHasNetworkLoadedOnce] = useState(false);
  const rightSidebarRef = useRef<HTMLDivElement | null>(null);
  const [showDirection, setShowDirection] = useState<boolean>(() => { const savedShowDirection = localStorage.getItem('showDirection'); return savedShowDirection !== null ? JSON.parse(savedShowDirection) : false; });
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState<LayerExportProgress | null>(null);
  const exportAbortControllerRef = useRef<AbortController | null>(null);
  const [, setSurveyLayerTypes] = useState<string[]>([]);
  const [isHighZoom, setIsHighZoom] = useState<boolean>(false);
  const [surveyLayerPanelOpen, setSurveyLayerPanelOpen] = useState<boolean>(false);
  const [surveyLayerPanelSurveys, setSurveyLayerPanelSurveys] = useState<SurveyLayerEntry[]>([]);
  const [surveyLayerMapRenderingByKey, setSurveyLayerMapRenderingByKey] = useState<
    ReadonlyMap<string, string>
  >(() => new Map());
  const [highlightedPanelSurveySlug, setHighlightedPanelSurveySlug] = useState<string | null>(null);
  const highlightedMapSurveySlugRef = useRef<string | null>(null);
  const highlightedSurveyDropGeometriesRef = useRef<{
    readonly slug: string;
    readonly geometries: readonly unknown[];
  } | null>(null);
  const surveyImageDragSlugRef = useRef<string | null>(null);
  const pendingDragHighlightRestoreRef = useRef<{
    mapSlug: string | null;
    panelSlug: string | null;
  } | null>(null);
  const surveyDragDropReceivedRef = useRef(false);
  const surveyHighlightRequestIdRef = useRef(0);
  const surveyLayerPanelSurveysRef = useRef<SurveyLayerEntry[]>([]);
  surveyLayerPanelSurveysRef.current = surveyLayerPanelSurveys;

  // Playback state
  const [isPlaybackActive, setIsPlaybackActive] = useState(false);
  const [activeSurveySlug, setActiveSurveySlug] = useState<string | null>(null);
  const [playbackLayers, setPlaybackLayers] = useState<PlaybackLayer[]>([]);
  const [playbackIndex, setPlaybackIndex] = useState(0);
  const [playbackSyncMode, setPlaybackSyncMode] = useState<SyncMode>('image');
  const [playbackFocusOwnerLayerKey, setPlaybackFocusOwnerLayerKey] = useState<string | null>(null);
  const [playbackFocusMessage, setPlaybackFocusMessage] = useState<string | null>(null);
  const isPlaybackActiveRef = useRef(isPlaybackActive);
  isPlaybackActiveRef.current = isPlaybackActive;
  const playbackSyncModeRef = useRef<SyncMode>(playbackSyncMode);
  playbackSyncModeRef.current = playbackSyncMode;
  const playbackFocusOwnerLayerKeyRef = useRef<string | null>(playbackFocusOwnerLayerKey);
  playbackFocusOwnerLayerKeyRef.current = playbackFocusOwnerLayerKey;
  const playbackPinRef = useRef<InstanceType<typeof Graphic> | null>(null);
  const playbackPinPreferredLayerKeyRef = useRef<string | null>(null);
  const playbackPinSuppressedRef = useRef(false);
  const playbackPinSkipNextRecenterRef = useRef(false);
  const playbackPinExactPointRef = useRef<PlaybackPinPoint | null>(null);
  const playbackPinHandoffActiveRef = useRef(false);
  const playbackPinSkipNextEffectRef = useRef(false);

  const playbackPinLockedSyncValueRef = useRef<string | number | null>(null);
  const dropPinLandingApiRef = useRef<DropPinLandingApi | null>(null);
  const playbackLayerLoadPrefetchRef = useRef<{
    readonly cacheKey: string;
    readonly promise: Promise<{
      orderedLayers: PlaybackLayer[];
      hiddenLayerKeys: Set<string>;
    } | null>;
  } | null>(null);
  const playbackHiddenLayerKeysRef = useRef<Set<string>>(new Set());
  const [layerSelectOpen, setLayerSelectOpen] = useState(false);
  const [layerSelectData, setLayerSelectData] = useState<{
    surveySlug: string;
    surveyLabel: string;
    layers: Array<{ key: string; name: string }>;
  } | null>(null);
  const [isImageViewerWorkspaceOpen, setIsImageViewerWorkspaceOpen] = useState(false);
  const [imageViewerSplitPercent, setImageViewerSplitPercent] = useState(70);
  const playbackDownloadAllRef = useRef<PlaybackDownloadAllControls | null>(null);
  const [playbackCanDownloadAll, setPlaybackCanDownloadAll] = useState(false);
  const handlePlaybackDownloadAllControlsChange = useCallback(
    (controls: PlaybackDownloadAllControls | null) => {
      playbackDownloadAllRef.current = controls;
      setPlaybackCanDownloadAll((prev) => {
        const next = controls?.canDownload ?? false;
        return prev === next ? prev : next;
      });
    },
    [],
  );
  const handlePlaybackDownloadAll = useCallback(() => {
    playbackDownloadAllRef.current?.downloadAll();
  }, []);
  const [isPlaybackGridLoading, setIsPlaybackGridLoading] = useState(false);
  const [playbackLoadingSurveySlug, setPlaybackLoadingSurveySlug] = useState<
    string | null
  >(null);
  const playbackTimelineSyncValues = useMemo(
    () => buildPlaybackTimelineSyncValues(playbackLayers, playbackSyncMode),
    [playbackLayers, playbackSyncMode],
  );
  const currentPlaybackSyncValue = playbackTimelineSyncValues[playbackIndex] ?? null;
  const playbackMaxIndex =
    playbackTimelineSyncValues.length > 0
      ? playbackTimelineSyncValues.length - 1
      : 0;

  const beginSurveyLayerMapRender = (layerKey: string, layerName: string) => {
    const displayName = layerName.trim() || layerKey;
    setSurveyLayerMapRenderingByKey((prev) => {
      if (prev.get(layerKey) === displayName) {
        return prev;
      }
      const next = new Map(prev);
      next.set(layerKey, displayName);
      return next;
    });
  };

  const endSurveyLayerMapRender = (layerKey: string) => {
    setSurveyLayerMapRenderingByKey((prev) => {
      if (!prev.has(layerKey)) {
        return prev;
      }
      const next = new Map(prev);
      next.delete(layerKey);
      return next;
    });
  };
  const coverageLayerKeysRef = useRef<Set<string>>(new Set());
  const layerClickConfigRegistryRef = useRef<LayerClickConfigRegistry>({});
  const geoserverLayerRefs = useRef<Record<string, ArcGisLayerLike>>({});
  const surveyWmtsLayerKeysRef = useRef<Set<string>>(new Set());
  const pendingBringToTopLayerKeyRef = useRef<string | null>(null);

  const listSurveyVectorLayersAboveImagery = (): ArcGisLayerLike[] => {
    const vectors: ArcGisLayerLike[] = [];
    for (const [key, layer] of Object.entries(geoserverLayerRefs.current)) {
      if (!layer || surveyWmtsLayerKeysRef.current.has(key)) {
        continue;
      }
      vectors.push(layer);
    }
    return vectors;
  };

  const pinSurveyWmtsBelowOverlays = (): void => {
    if (!view?.map || surveyWmtsLayerKeysRef.current.size === 0) {
      return;
    }
    const defectIds = activeDefectLayerIdsRef.current;
    const vectors = listSurveyVectorLayersAboveImagery();
    if (defectIds.length === 0 && vectors.length === 0) {
      return;
    }
    for (const key of surveyWmtsLayerKeysRef.current) {
      const layer = geoserverLayerRefs.current[key];
      if (!layer) {
        continue;
      }
      placeLayerBelowSdmOverlays(view.map, layer, defectIds, {
        layersAboveImagery: vectors,
      });
    }
    if (typeof view.requestRender === 'function') {
      view.requestRender();
    }
  };

  useEffect(() => {
    pinSurveyWmtsBelowOverlays();
    }, [view, activeDefectLayers, defectOverlayLoading]);
  const wfsColorIndexRef = useRef<number>(0);
  const prevShowTravelDirectionArrowsRef = useRef<boolean | null>(null);
  const prevSurveyWfsPointZoomRef = useRef<number | null>(null);
  const surveyManagerActions = useSurveyManagerActions();
  const currentTenant = localStorage.getItem('tenantId');
  const [tenant, setTenant] = useState(() => (localStorage.getItem('tenantId') || '').replace(/['"]+/g, ''),);

  const clearHighlight = () => {
    if (highlight !== null) {
      highlight.remove();
      highlight = null;
    }
    highlightedSurveyDropGeometriesRef.current = null;
  };

  useEffect(() => {
    const handleStorageChange = () => {
      setTenant((localStorage.getItem('tenantId') || '').replace(/['"]+/g, ''));
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  useEffect(() => {
    if (!view) {
      return;
    }
    const handlePanToDefectExtent = (event: Event) => {
      const detail = (event as CustomEvent<{ readonly viewId?: string }>).detail;
      const viewId = detail?.viewId?.trim();
      if (!viewId) {
        return;
      }
      void (async () => {
        // Read the store directly so layers just activated by turning on defects are
        // visible even before this component re-renders and refreshes the ref
        const activeLayers = selectActiveDefectLayers(store.getState());
        const center = await resolveDefectExtentCenter(view, {
          viewId,
          activeLayers,
        });
        if (!center) {
          return;
        }
        const viewExtent = view.extent as
          | {
              xmin: number;
              ymin: number;
              xmax: number;
              ymax: number;
            }
          | null
          | undefined;
        if (!isExtentCenterOffScreen(center, viewExtent)) {
          return;
        }
        try {
          const centerPoint = new Point({
            x: center.x,
            y: center.y,
            spatialReference:
              center.spatialReference ??
              view.spatialReference ??
              { wkid: 3857 },
          });
          await view.goTo(
            { center: centerPoint },
            getSdmPanToDefectGoToOptions(),
          );
        } catch (error) {
          console.warn('Failed to pan map to SDM defect extent centre', error);
        }
      })();
    };
    window.addEventListener(
      SDM_PAN_TO_DEFECT_EXTENT_EVENT,
      handlePanToDefectExtent,
    );
    return () => {
      window.removeEventListener(
        SDM_PAN_TO_DEFECT_EXTENT_EVENT,
        handlePanToDefectExtent,
      );
    };
  }, [view]);

  // Auto-collapse the right toolbar whenever playback or the image workspace opens.
  useEffect(() => {
    if (isPlaybackActive || isImageViewerWorkspaceOpen) {
      setSecondaryIsExpanded(false);
    }
  }, [isPlaybackActive, isImageViewerWorkspaceOpen]);

  useEffect(() => {
    const handleWorkspaceSplit = (ev: Event) => {
      const detail = (ev as CustomEvent<ImageViewerWorkspaceSplitDetail>).detail;
      if (!detail) return;
      setIsImageViewerWorkspaceOpen(detail.open);
      setImageViewerSplitPercent(detail.percent);
    };
    window.addEventListener(
      IMAGE_VIEWER_WORKSPACE_SPLIT_EVENT,
      handleWorkspaceSplit as EventListener,
    );
    return () => {
      window.removeEventListener(
        IMAGE_VIEWER_WORKSPACE_SPLIT_EVENT,
        handleWorkspaceSplit as EventListener,
      );
    };
  }, []);

  useEffect(() => {
    if (isInspectionsToolkitPath(location.pathname)) {
      showModal('Inspections Toolkit');
    } else if (modalState['Inspections Toolkit']) {
      setModalState((prevState) => ({ ...prevState, 'Inspections Toolkit': false }));
    }
  }, [location.pathname]);

  // Keep the map DOM/canvas full-width; mapContainer already reserves
  // the collapsed navbar/toolbar rails. Expanding those panels must not change
  // view.padding (that would shift the map). Only image-viewer split uses
  // padding. Extra rail width is applied as CSS offsets on Esri UI corners so
  // scale bar / zoom stay clear of the overlay without moving the map.
  useLayoutEffect(() => {
    if (!view) return;

    const mapContainer = document.querySelector('.xa-map-container');
    if (!(mapContainer instanceof HTMLElement)) {
      return;
    }

    const collapsedRailPx = (): number => {
      const rootFontSize = parseFloat(
        getComputedStyle(document.documentElement).fontSize,
      );
      return Number.isFinite(rootFontSize) ? rootFontSize * 4.8 : 48;
    };

    const applyLayout = (): void => {
      const rail = collapsedRailPx();
      const navbar = document.querySelector('.xa-navbar');
      const toolbar =
        rightSidebarRef.current ?? document.querySelector('.xa-toolbar');

      const leftExtra =
        navbar instanceof HTMLElement
          ? Math.max(0, navbar.offsetWidth - rail)
          : 0;
      const rightExtra =
        toolbar instanceof HTMLElement
          ? Math.max(0, toolbar.offsetWidth - rail)
          : 0;

      mapContainer.style.setProperty(
        '--xa-map-ui-offset-left',
        `${leftExtra}px`,
      );
      mapContainer.style.setProperty(
        '--xa-map-ui-offset-right',
        `${rightExtra}px`,
      );

      let splitRight = 0;
      const activeSplitPercent = isImageViewerWorkspaceOpen
        ? imageViewerSplitPercent
        : null;
      if (activeSplitPercent !== null) {
        const mapRect = mapContainer.getBoundingClientRect();
        const splitterLeft = (activeSplitPercent / 100) * window.innerWidth;
        splitRight = Math.max(0, Math.round(mapRect.right - splitterLeft));
      }

      view.padding = {
        left: 0,
        top: 0,
        bottom: 0,
        right: splitRight,
      };
    };

    applyLayout();

    const resizeObserver = new ResizeObserver(() => {
      applyLayout();
    });

    const navbar = document.querySelector('.xa-navbar');
    if (navbar instanceof HTMLElement) {
      resizeObserver.observe(navbar);
    }

    const toolbar =
      rightSidebarRef.current ?? document.querySelector('.xa-toolbar');
    if (toolbar instanceof HTMLElement) {
      resizeObserver.observe(toolbar);
    }

    return () => {
      resizeObserver.disconnect();
      mapContainer.style.removeProperty('--xa-map-ui-offset-left');
      mapContainer.style.removeProperty('--xa-map-ui-offset-right');
    };
  }, [
    view,
    isImageViewerWorkspaceOpen,
    imageViewerSplitPercent,
    primaryIsExpanded,
    secondaryIsExpanded,
  ]);

  // Prefetch client-side projection engine once the map exists.
  useEffect(() => {
    if (!view) return;
    loadProjectOperator().catch(() => {});
  }, [view]);

  // Place / move the playback position pin whenever the current index changes.
  // During a drop-fall overlay the map pin is suppressed so only one pin is visible.
  useEffect(() => {
    if (!view) return;

    const removePlaybackPin = () => {
      if (!playbackPinRef.current) {
        return;
      }
      try {
        view.graphics.remove(playbackPinRef.current);
      } catch {
        // ignore
      }
      playbackPinRef.current = null;
    };

    if (playbackPinSkipNextEffectRef.current) {
      playbackPinSkipNextEffectRef.current = false;
      return;
    }

    if (playbackPinSuppressedRef.current) {
      if (!playbackPinHandoffActiveRef.current) {
        removePlaybackPin();
      }
      return;
    }

    if (playbackPinHandoffActiveRef.current && playbackPinRef.current) {
      return;
    }

   
    if (
      playbackPinRef.current &&
      playbackPinLockedSyncValueRef.current !== null &&
      playbackPinLockedSyncValueRef.current === currentPlaybackSyncValue
    ) {
      playbackPinExactPointRef.current = null;
      return;
    }
    playbackPinLockedSyncValueRef.current = null;

    let pinPoint: PlaybackPinPoint | null = null;

    const exactFromDrop = playbackPinExactPointRef.current;
    if (
      exactFromDrop &&
      typeof exactFromDrop.x === 'number' &&
      typeof exactFromDrop.y === 'number'
    ) {
      pinPoint = exactFromDrop;
      playbackPinExactPointRef.current = null;
    } else if (isPlaybackActive && playbackLayers.length > 0) {
      const resolved = resolvePlaybackPinPoint(
        playbackLayers,
        currentPlaybackSyncValue,
        playbackSyncMode,
        [
          playbackPinPreferredLayerKeyRef.current,
          playbackFocusOwnerLayerKey,
        ],
      );
      if (
        resolved &&
        typeof resolved.x === 'number' &&
        typeof resolved.y === 'number'
      ) {
        pinPoint = {
          x: resolved.x,
          y: resolved.y,
          spatialReference: resolved.spatialReference,
        };
      }
    }

    if (!pinPoint) {
      if (!isPlaybackActive) {
        removePlaybackPin();
      }
      return;
    }

    const targetPinPoint: PlaybackPinPoint = pinPoint;

    const targetPoint = new Point({
      x: targetPinPoint.x,
      y: targetPinPoint.y,
      spatialReference:
        targetPinPoint.spatialReference ?? view.spatialReference ?? { wkid: 3857 },
    });

    const existingPin = playbackPinRef.current;
    const existingGeometry = existingPin?.geometry as
      | { x?: number; y?: number }
      | null
      | undefined;
    const hasExistingPoint =
      existingPin != null &&
      typeof existingGeometry?.x === 'number' &&
      typeof existingGeometry?.y === 'number';

    if (hasExistingPoint && existingPin && existingGeometry) {
      const samePoint =
        Math.abs((existingGeometry.x ?? 0) - targetPinPoint.x) < 1e-6 &&
        Math.abs((existingGeometry.y ?? 0) - targetPinPoint.y) < 1e-6;
      if (samePoint) {
        return;
      }
      try {
        existingPin.geometry = targetPoint;
      } catch {
        existingGeometry.x = targetPinPoint.x;
        existingGeometry.y = targetPinPoint.y;
      }
      return;
    }

    const pin = new Graphic({
      geometry: targetPoint,
      symbol: new PictureMarkerSymbol({
        url: dropPinIconUrl,
        width: '24px',
        height: '36px',
        yoffset: 18,
      }),
    });
    view.graphics.add(pin);
    playbackPinRef.current = pin;

    if (playbackPinSkipNextRecenterRef.current) {
      playbackPinSkipNextRecenterRef.current = false;
      return;
    }

    const extent = view.extent as
      | { xmin: number; ymin: number; xmax: number; ymax: number }
      | undefined;
    if (extent && isMapPointOutsidePaddedExtent(
      { x: targetPoint.x, y: targetPoint.y },
      extent,
    )) {
      view
        .goTo(
          { target: targetPoint },
          { duration: DROP_PIN_RECENTER_DURATION_MS, easing: 'ease-in-out' },
        )
        .catch(() => {});
    }
  }, [
    currentPlaybackSyncValue,
    isPlaybackActive,
    playbackFocusOwnerLayerKey,
    playbackLayers,
    playbackSyncMode,
    view,
  ]);

  // Tear down the map pin when playback stops.
  useEffect(() => {
    if (!view) return;
    if (isPlaybackActive) {
      return;
    }
    playbackPinSuppressedRef.current = false;
    if (playbackPinRef.current) {
      try {
        view.graphics.remove(playbackPinRef.current);
      } catch {
        // ignore
      }
      playbackPinRef.current = null;
    }
  }, [isPlaybackActive, view]);

  const clusterConfig = {
    type: 'cluster',
    clusterRadius: '150px',
    clusterMaxSize: '84px',
    clusterMinSize: '44px',
    labelingInfo: [
      {
        symbol: {
          type: 'text',
          color: 'white',
          haloColor: 'black',
          haloSize: '1px',
          font: {
            size: 12,
            weight: 'bold',
          },
        },
        labelPlacement: 'center-center',
        labelExpressionInfo: {
          expression: "Text($feature.cluster_count, '#,###')",
        },
      },
    ],
  };

  const onSelectNode = (currentSearchContent: SearchDetails) => {
    const lyr = view.map.layers;
    lyr.forEach((layer: ArcGisLayerLike) => {
      if (layer.id === currentSearchContent.selectedKey) {
        const parcelQuery = {
          spatialRelationship: 'intersects',
          where: `name = '${currentSearchContent.selectedItem}'`,
          outFields: ['*'],
          returnGeometry: true,
        };

        if (!layer.queryFeatures) {
          return;
        }

        view.whenLayerView(layer).then((layerView: ArcGisLayerViewLike) => {
          layer.queryFeatures?.(parcelQuery).then((results: ArcGisQueryResultLike) => {
            const feature = results.features[0];
            if (feature?.attributes) {
              setAttributesSourceActiveLayerId(null);
              setAttributesModalData({ ...feature.attributes });
              showModal('Attributes');

              clearHighlight();
              highlight = layerView.highlight(feature.attributes['__OBJECTID']);
              view.goTo(
                {
                  target: feature.geometry,
                  zoom: 16,
                },
                {
                  duration: 2000,
                  easing: 'in-out-expo',
                },
              );
            } else {
              const newAttributesModalData: { name?: string; category?: string } & UnknownRecord = {
                name: currentSearchContent.selectedItem,
                category: 'network',
              };
              setAttributesSourceActiveLayerId(null);
              setAttributesModalData(newAttributesModalData);
              showModal('Attributes');
              clearHighlight();
              view.goTo(
                {
                  target: layer.fullExtent,
                },
                {
                  duration: 2000,
                  easing: 'in-out-expo',
                },
              );
            }
          });
        });
      }
    });
  };

  const onCloseAttributesModal = (title: string) => {
    clearHighlight();
    if (view) {
      if (isPlaybackActive && playbackPinRef.current) {
        const preserveGraphic = playbackPinRef.current;
        const graphicsCollection = view.graphics as {
          toArray?: () => unknown[];
          removeMany?: (graphics: unknown[]) => void;
          removeAll: () => void;
        };
        if (
          typeof graphicsCollection.toArray === 'function' &&
          typeof graphicsCollection.removeMany === 'function'
        ) {
          const removableGraphics = graphicsCollection
            .toArray()
            .filter((graphic) => graphic !== preserveGraphic);
          if (removableGraphics.length) {
            graphicsCollection.removeMany(removableGraphics);
          }
        } else {
          view.graphics.removeAll();
        }
      } else {
        view.graphics.removeAll();
      }
    }
    setAttributesModalData(null);
    setAttributesSourceActiveLayerId(null);
    onCloseModal(title);
  };

  // Close the selected-feature panel when its source active layer is toggled off or removed.
  useEffect(() => {
    if (
      !modalState['Attributes'] ||
      !shouldCloseAttributesForActiveLayer(
        attributesSourceActiveLayerId,
        activeDefectLayers,
      )
    ) {
      return;
    }
    onCloseAttributesModal('Attributes');
  }, [activeDefectLayers, attributesSourceActiveLayerId, modalState]);

  // Survey Layer Panel handlers

  const addSurveyToPanel = async (data: SurveyPanelInput) => {
    if (!data?.survey_type || !data?.survey_slug) return;
    const slug = data.survey_slug as string;
    const surveyType = data.survey_type as string;

    // Deduplicate: if the survey is already loaded in the panel, don't re-fetch and
    // overwrite its layers.
    if (surveyLayerPanelSurveysRef.current.some((e) => e.surveySlug === slug)) {
      return;
    }

    setSurveyLayerPanelSurveys((prev) => [
      ...prev,
      {
        surveySlug: slug,
        displayLabel: surveyType,
        layers: [],
        loading: true,
      },
    ]);

    try {
      const survey = await surveyManagerActions.getSurvey(slug);
      const surveyShapefiles = await surveyManagerActions.getSurveyShapefiles(
        slug,
        false,
        { category: 'camera' },
      );
      const shapefiles = (surveyShapefiles?.shapefiles ||
        []) as readonly SurveyShapefileSummary[];
      const surveyYear =
        shapefiles.length > 0 && shapefiles[0]?.slug
          ? extractSurveyYear(shapefiles[0].slug)
          : '';
      const layersAccum: SurveyLayerEntry['layers'] = [];

      await Promise.all(
        shapefiles
          .filter((shp) => Boolean(shp?.slug))
          .map(async (shp) => {
            try {
              const filePath = shp.filePath
                ? `${shp.filePath}&outputFormat=application%2Fjson`
                : '';
              const layerName = findSurveyLayer(
                String(shp.slug),
                survey.layers || [],
              );
              if (!layerName) {
                return;
              }
              const layerSlug = toSlugFormat(layerName);
              const layerType = await surveyManagerActions
                .getLayerType(layerSlug)
                .catch(() => null);
              const resolvedLayerType = layerType?.category || '';
              if (layerType?.category === 'WMTS') {
                const sourceSlug = String(shp.slug);
                layersAccum.push({
                  key: buildSurveyWmtsLayerKey({
                    sourceSlug,
                    layerName,
                    surveySlug: slug,
                    surveyType: survey.surveyType,
                    surveyYear,
                  }),
                  name: layerName,
                  type: resolvedLayerType,
                  endpoint: shp.filePath ?? '',
                  sourceSlug,
                  checked: false,
                });
              } else {
                layersAccum.push({
                  key: `${survey.slug}_${layerName}`,
                  name: layerName,
                  type: resolvedLayerType,
                  endpoint: filePath + `&CQL_FILTER=survey_slug='${slug}'`,
                  checked: false,
                });
              }
            } catch {
              // ignore per-shapefile errors
            }
          }),
      );

      const checkedNetworkWmtsNames = new Set<string>();
      for (const e of surveyLayerPanelSurveysRef.current) {
        if (e.surveySlug === slug) continue;
        if (e.surveyType === survey.surveyType && e.surveyYear === surveyYear) {
          for (const l of e.layers) {
            if (
              l.checked &&
              isPanelSurveyWmtsLayer(l) &&
              resolveLayerOrthoScope(l) === 'network'
            ) {
              checkedNetworkWmtsNames.add(l.name);
            }
          }
        }
      }

      const finalLayers = layersAccum.map((l) => {
        if (
          isPanelSurveyWmtsLayer(l) &&
          resolveLayerOrthoScope(l) === 'network' &&
          checkedNetworkWmtsNames.has(l.name)
        ) {
          return { ...l, checked: true, loading: true, error: undefined };
        }
        return l;
      });

      const sortedFinalLayers = [...finalLayers].sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      const pendingAutoLayers = sortedFinalLayers.filter((l) => !!l.loading);

      setSurveyLayerPanelSurveys((prev) =>
        prev.map((e) =>
          e.surveySlug === slug
            ? {
                ...e,
                layers: sortedFinalLayers,
                // Keep survey-level loading until auto-enabled layers have painted.
                loading: pendingAutoLayers.length > 0,
                surveyType: survey.surveyType,
                surveyYear,
                displayLabel: buildSurveyLabel(
                  survey.surveyType,
                  survey.surveyDate,
                  survey.runNumber,
                ),
              }
            : e,
        ),
      );

      // Dispatch after panel state is updated so settle can clear loading flags.
      for (const layer of pendingAutoLayers) {
        window.dispatchEvent(
          new CustomEvent('attributes:toggle-layer', {
            detail: {
              endpoint: layer.endpoint,
              enabled: true,
              layer: { key: layer.key, name: layer.name, type: layer.type },
            },
          }),
        );
      }
    } catch (err: unknown) {
      setSurveyLayerPanelSurveys((prev) =>
        prev.map((e) =>
          e.surveySlug === slug
            ? {
                ...e,
                loading: false,
                error:
                  err instanceof Error ? err.message : 'Failed to load layers',
              }
            : e,
        ),
      );
    }
  };

  const toggleSurveyLayer = (surveySlug: string, layerKey: string, enabled: boolean) => {
    if (!enabled) {
      window.dispatchEvent(
        new CustomEvent('image-viewer:close-layer', { detail: { layerKey } }),
      );
    }
    setSurveyLayerPanelSurveys((prev) => {
      // Network-wide (survey-year) WMTS orthos still cross-link
      // Survey-specific (date+run) orthos stay independent
      const sourceEntry = prev.find((e) => e.surveySlug === surveySlug);
      const sourceLayer = sourceEntry?.layers.find((l) => l.key === layerKey);
      const sourceLinksNetworkWmts =
        sourceLayer != null &&
        isPanelSurveyWmtsLayer(sourceLayer) &&
        resolveLayerOrthoScope(sourceLayer) === 'network';

      return prev.map((entry) => {
        const isSourceEntry = entry.surveySlug === surveySlug;

        const isLinkedEntry =
          sourceLinksNetworkWmts &&
          sourceLayer != null &&
          !isSourceEntry &&
          entry.surveyType !== undefined &&
          entry.surveyYear !== undefined &&
          entry.surveyType === sourceEntry?.surveyType &&
          entry.surveyYear === sourceEntry?.surveyYear &&
          entry.layers.some((layer) => shouldLinkWmtsLayers(sourceLayer, layer));

        if (!isSourceEntry && !isLinkedEntry) return entry;

        return {
          ...entry,
          layers: entry.layers.map((layer) => {
            // Source entry: update the specifically toggled layer
            if (isSourceEntry && layer.key === layerKey) {
              const isWfs = isWfsImageLayer(layer);
              let assignedColor: string | undefined = layer.color;
              if (enabled && isWfs) {
                assignedColor = WFS_LAYER_PALETTE[wfsColorIndexRef.current % WFS_LAYER_PALETTE.length];
                wfsColorIndexRef.current += 1;
              } else if (!enabled) {
                assignedColor = undefined;
              }
              window.dispatchEvent(
                new CustomEvent('attributes:toggle-layer', {
                  detail: { endpoint: layer.endpoint, enabled, color: assignedColor, layer: { key: layer.key, name: layer.name, type: layer.type } },
                }),
              );
              return {
                ...layer,
                checked: enabled,
                color: assignedColor,
                loading: enabled,
                error: undefined,
              };
            }

            if (
              isLinkedEntry &&
              sourceLayer != null &&
              shouldLinkWmtsLayers(sourceLayer, layer)
            ) {
              window.dispatchEvent(
                new CustomEvent('attributes:toggle-layer', {
                  detail: { endpoint: layer.endpoint, enabled, layer: { key: layer.key, name: layer.name, type: layer.type } },
                }),
              );
              return {
                ...layer,
                checked: enabled,
                loading: enabled,
                error: undefined,
              };
            }

            return layer;
          }),
        };
      });
    });
  };

  const forceMapLayerStackPaint = (
    mapView: ArcGisViewLike,
    layer: ArcGisLayerLike,
    options?: { readonly refreshTiles?: boolean },
  ): void => {
    const paint = (): void => {
      if (typeof mapView.requestRender === 'function') {
        mapView.requestRender();
      }
    };

    paint();

    if (options?.refreshTiles && typeof layer.refresh === 'function') {
      try {
        layer.refresh();
      } catch {
      }
    }

    window.requestAnimationFrame(() => {
      paint();
      window.requestAnimationFrame(paint);
    });
  };

  const resolveMapLayerForBringToTop = (
    layerKey: string,
  ): ArcGisLayerLike | undefined => {
    const normalizedKey = String(layerKey ?? '').replace(/^favourites_/, '');
    return (
      geoserverLayerRefs.current[normalizedKey] ??
      geoserverLayerRefs.current[layerKey] ??
      layerData[normalizedKey] ??
      layerData[layerKey] ??
      (typeof view?.map?.findLayerById === 'function'
        ? view.map.findLayerById(normalizedKey) ??
          view.map.findLayerById(layerKey)
        : undefined)
    );
  };

  const bringGeoserverLayerToTop = (layerKey: string) => {
    if (!view?.map) {
      return;
    }
    const normalizedKey = String(layerKey ?? '').replace(/^favourites_/, '');
    pendingBringToTopLayerKeyRef.current = normalizedKey;
    const lyr = resolveMapLayerForBringToTop(normalizedKey);
    if (!lyr) {
      return;
    }
    const treatAsWmts =
      surveyWmtsLayerKeysRef.current.has(normalizedKey) ||
      surveyWmtsLayerKeysRef.current.has(layerKey) ||
      isSurveyWmtsLayer(lyr);
    bringSurveyLayerForward(view.map, lyr, activeDefectLayerIdsRef.current, {
      forceWmts: treatAsWmts,
      layersAboveImagery: treatAsWmts
        ? listSurveyVectorLayersAboveImagery()
        : undefined,
    });
    forceMapLayerStackPaint(view, lyr, { refreshTiles: treatAsWmts });
    if (!treatAsWmts) {
      // WFS raised — keep ortho underneath.
      pinSurveyWmtsBelowOverlays();
    }
  };

  const zoomSurveyLayerToExtent = (layerKey: string): void => {
    const lyr = geoserverLayerRefs.current[layerKey];
    if (lyr?.fullExtent && view) {
      stopMapViewAnimation(view);
      void view
        .goTo(lyr.fullExtent, {
          duration: SURVEY_MAP_FLY_TO_DURATION_MS,
          easing: SURVEY_MAP_FLY_TO_EASING,
        })
        .catch(() => {});
    }
  };

  const cancelShapefileExport = (): void => {
    const controller = exportAbortControllerRef.current;
    if (controller) {
      controller.abort();
    }
  };

  const emapsiteBasemapsEnabled = !isSurveyPlayerTenant(currentTenant);

  const clearMapGraphicsPreservingPlaybackPin = () => {
    if (!view) return;
    if (isPlaybackActive && playbackPinRef.current) {
      const preserveGraphic = playbackPinRef.current;
      const graphicsCollection = view.graphics as {
        toArray?: () => unknown[];
        removeMany?: (graphics: unknown[]) => void;
        removeAll: () => void;
      };
      if (typeof graphicsCollection.toArray === 'function' && typeof graphicsCollection.removeMany === 'function') {
        const removableGraphics = graphicsCollection
          .toArray()
          .filter((graphic) => graphic !== preserveGraphic);
        if (removableGraphics.length) {
          graphicsCollection.removeMany(removableGraphics);
        }
        return;
      }
    }
    view.graphics.removeAll();
  };

  const collectDropGeometriesFromFeatures = (
    features: readonly ArcGisGraphicLike[],
    dropGeometries: unknown[],
  ): void => {
    for (const feature of features) {
      if (feature?.geometry) {
        dropGeometries.push(feature.geometry);
      }
    }
  };

  const queryLayerFeaturesForSurveyHighlight = async (
    lyr: ArcGisLayerLike,
    where: string,
  ): Promise<ArcGisGraphicLike[]> => {
    if (typeof lyr.queryFeatures !== 'function') {
      return [];
    }
    try {
      const results = await lyr.queryFeatures({
        where,
        returnGeometry: true,
        outFields: ['*'],
      });
      return results?.features?.length > 0 ? results.features : [];
    } catch {
      return [];
    }
  };

  const loadDropGeometriesFromPanelWfs = async (
    surveySlug: string,
    requestId: number,
  ): Promise<readonly unknown[]> => {
    const entry = surveyLayerPanelSurveysRef.current.find(
      (e) => e.surveySlug === surveySlug,
    );
    if (!entry) {
      return [];
    }

    const selectedKeys = resolvePlaybackWfsLayerSelection(
      entry.layers,
      MAX_SIMULTANEOUS_IMAGES,
    ).keys;
    if (selectedKeys.length === 0) {
      return [];
    }

    const selectedKeySet = new Set(selectedKeys);
    const wfsLayers = entry.layers.filter(
      (layer) => selectedKeySet.has(layer.key) && isWfsImageLayer(layer),
    );

    const dropGeometries: unknown[] = [];

    for (const layerNode of wfsLayers) {
      if (requestId !== surveyHighlightRequestIdRef.current) {
        return [];
      }
      const layerRef = geoserverLayerRefs.current[layerNode.key];
      if (!layerRef) {
        continue;
      }
      const features = await queryLayerFeaturesForSurveyHighlight(
        layerRef,
        '1=1',
      );
      if (requestId !== surveyHighlightRequestIdRef.current) {
        return [];
      }
      collectDropGeometriesFromFeatures(features, dropGeometries);
      if (dropGeometries.length > 0) {
        return dropGeometries;
      }
    }

    const firstWfs = wfsLayers[0];
    if (!firstWfs) {
      return [];
    }
    try {
      // @ts-expect-error
      const TempGeoJSONLayer = (await import('@arcgis/core/layers/GeoJSONLayer'))
        .default;
      if (requestId !== surveyHighlightRequestIdRef.current) {
        return [];
      }
      const layerRef = new TempGeoJSONLayer({
        url: firstWfs.endpoint,
      }) as ArcGisLayerLike;
      try {
        await layerRef.load?.();
      } catch {
        return [];
      }
      if (requestId !== surveyHighlightRequestIdRef.current) {
        return [];
      }
      const features = await queryLayerFeaturesForSurveyHighlight(
        layerRef,
        '1=1',
      );
      if (requestId !== surveyHighlightRequestIdRef.current) {
        return [];
      }
      collectDropGeometriesFromFeatures(features, dropGeometries);
    } catch {
      return [];
    }

    return dropGeometries;
  };

  const highlightSurveyOnMap = async (
    surveySlug: string,
    options?: { readonly flyToIfOutOfView?: boolean },
  ) => {
    const requestId = ++surveyHighlightRequestIdRef.current;
    const shouldFlyToIfOutOfView = options?.flyToIfOutOfView === true;
    setHighlightedPanelSurveySlug(surveySlug);
    if (!view) return;
    clearHighlight();
    clearMapGraphicsPreservingPlaybackPin();

    const layers = view.map.layers.toArray();
    const allFeatures: ArcGisGraphicLike[] = [];
    const dropGeometries: unknown[] = [];
    let firstLayerView: ArcGisLayerViewLike | null = null;
    let foundFeatures = false;

    for (const lyr of layers) {
      if (typeof lyr.queryFeatures !== 'function') continue;
      try {
        const results = await lyr.queryFeatures({
          where: `survey_slug = '${surveySlug}'`,
          returnGeometry: true,
          outFields: ['*'],
        });
        if (requestId !== surveyHighlightRequestIdRef.current) return;
        if (results?.features?.length > 0) {
          foundFeatures = true;
          collectDropGeometriesFromFeatures(results.features, dropGeometries);
          if (shouldFlyToIfOutOfView) {
            allFeatures.push(...results.features);
          }
          if (!firstLayerView) {
            firstLayerView = await view.whenLayerView(lyr).catch(() => null);
            if (requestId !== surveyHighlightRequestIdRef.current) return;
            if (firstLayerView) {
              highlight = firstLayerView.highlight(results.features);
            }
          }
        }
      } catch (_e) {
        // layer doesn't support this query - skip
      }
    }

    let panelWfsFallbackGeometries: readonly unknown[] = [];
    if (!foundFeatures) {
      panelWfsFallbackGeometries = await loadDropGeometriesFromPanelWfs(
        surveySlug,
        requestId,
      );
      if (requestId !== surveyHighlightRequestIdRef.current) return;
    }

    if (requestId !== surveyHighlightRequestIdRef.current) return;
    const dropCache = resolvePegmanDropGeometryCache(surveySlug, {
      mapSurveySlugGeometries: dropGeometries,
      panelWfsFallbackGeometries,
    });
    highlightedMapSurveySlugRef.current = dropCache ? surveySlug : null;
    highlightedSurveyDropGeometriesRef.current = dropCache;

    if (!shouldFlyToIfOutOfView || allFeatures.length === 0) {
      return;
    }

    let target: unknown = null;
    try {
      const geometries = allFeatures
        .map((feature) => feature.geometry)
        .filter((geometry): geometry is NonNullable<typeof geometry> =>
          Boolean(geometry),
        );
      if (geometries.length > 0) {
        const combined =
          geometries.length === 1
            ? geometries[0]
            : geometryEngine.union(geometries);
        const extent = combined?.extent;
        if (extent) {
          // Use the survey extent for out-of-view checks / pan center only.
          target = extent;
        }
      }
    } catch {
      // Skip pan if extent union fails.
    }

    if (target == null) {
      return;
    }

    void flyToSurveyHighlightIfOutOfView(view, target, {
      isCancelled: () => requestId !== surveyHighlightRequestIdRef.current,
    });
  };

  const restoreSurveyHighlightAfterFailedDrop = () => {
    const snapshot = pendingDragHighlightRestoreRef.current;
    pendingDragHighlightRestoreRef.current = null;
    if (!snapshot) return;

    if (!snapshot.mapSlug) {
      clearHighlight();
      highlightedMapSurveySlugRef.current = null;
      highlightedSurveyDropGeometriesRef.current = null;
      clearMapGraphicsPreservingPlaybackPin();
      setHighlightedPanelSurveySlug(snapshot.panelSlug);
      return;
    }

    void highlightSurveyOnMap(snapshot.mapSlug);
  };

  const handleSurveyImageDragStart = (surveySlug: string) => {
    surveyDragDropReceivedRef.current = false;
    surveyImageDragSlugRef.current = surveySlug;
    if (!pendingDragHighlightRestoreRef.current) {
      pendingDragHighlightRestoreRef.current = {
        mapSlug: highlightedMapSurveySlugRef.current,
        panelSlug: highlightedPanelSurveySlug,
      };
    }
    void highlightSurveyOnMap(surveySlug);
  };

  const handleSurveyImageDragEnd = (): boolean => {
    surveyImageDragSlugRef.current = null;
    if (surveyDragDropReceivedRef.current) {
      surveyDragDropReceivedRef.current = false;
      return true;
    }
    return false;
  };

  const handleSurveyImageDragCancel = () => {
    restoreSurveyHighlightAfterFailedDrop();
  };

  const handleStopPlayback = () => {
    playbackHiddenLayerKeysRef.current.forEach((key) => {
      const layerRef = geoserverLayerRefs.current[key];
      if (layerRef) layerRef.visible = true;
    });
    playbackHiddenLayerKeysRef.current = new Set();
    playbackPinPreferredLayerKeyRef.current = null;
    playbackPinSuppressedRef.current = false;
    playbackPinExactPointRef.current = null;
    playbackPinSkipNextRecenterRef.current = false;
    playbackPinHandoffActiveRef.current = false;
    playbackPinSkipNextEffectRef.current = false;
    playbackPinLockedSyncValueRef.current = null;
    playbackLayerLoadPrefetchRef.current = null;
    dropPinLandingApiRef.current?.abortLanding();
    setIsPlaybackActive(false);
    setActiveSurveySlug(null);
    setPlaybackLayers([]);
    setPlaybackIndex(0);
    setPlaybackSyncMode('image');
    setPlaybackFocusOwnerLayerKey(null);
    setPlaybackFocusMessage(null);
    setIsPlaybackGridLoading(false);
    setPlaybackLoadingSurveySlug(null);
    playbackDownloadAllRef.current = null;
    setPlaybackCanDownloadAll(false);
    setLayerSelectOpen(false);
    setLayerSelectData(null);
  };

  const removeSurveyFromPanel = (surveySlug: string) => {
    if (activeSurveySlug === surveySlug) {
      handleStopPlayback();
    }
    if (highlightedPanelSurveySlug === surveySlug) {
      setHighlightedPanelSurveySlug(null);
    }

    window.dispatchEvent(
      new CustomEvent('image-viewer:close-survey', { detail: { surveySlug } }),
    );

    clearHighlight();
    clearMapGraphicsPreservingPlaybackPin();

    setSurveyLayerPanelSurveys((prev) => {
      const entry = prev.find((e) => e.surveySlug === surveySlug);
      const remaining = prev.filter((e) => e.surveySlug !== surveySlug);
      if (entry) {
        entry.layers.filter((l) => l.checked).forEach((layer) => {
          // Keep network-wide WMTS on the map if another survey still has it checked.
          if (
            isPanelSurveyWmtsLayer(layer) &&
            resolveLayerOrthoScope(layer) === 'network'
          ) {
            const sharedAndChecked = remaining.some(
              (e) =>
                e.surveyType === entry.surveyType &&
                e.surveyYear === entry.surveyYear &&
                e.layers.some(
                  (l) =>
                    l.checked &&
                    shouldLinkWmtsLayers(layer, l),
                ),
            );
            if (sharedAndChecked) return;
          }
          window.dispatchEvent(
            new CustomEvent('attributes:toggle-layer', {
              detail: { endpoint: layer.endpoint, enabled: false, layer: { key: layer.key, name: layer.name, type: layer.type } },
            }),
          );
        });
      }
      return remaining;
    });
  };

  const closeSurveyLayerPanel = () => {
    handleStopPlayback();
    setHighlightedPanelSurveySlug(null);

    clearHighlight();
    clearMapGraphicsPreservingPlaybackPin();
    setSurveyLayerPanelSurveys((prev) => {
      prev.forEach((entry) => {
        window.dispatchEvent(
          new CustomEvent('image-viewer:close-survey', { detail: { surveySlug: entry.surveySlug } }),
        );
        entry.layers.filter((l) => l.checked).forEach((layer) => {
          window.dispatchEvent(
            new CustomEvent('attributes:toggle-layer', {
              detail: { endpoint: layer.endpoint, enabled: false, layer: { key: layer.key, name: layer.name, type: layer.type } },
            }),
          );
        });
      });
      return [];
    });
    setSurveyLayerPanelOpen(false);
  };

  const loadPlaybackLayersForSurvey = async (
    surveySlug: string,
    selectedLayerKeys: string[],
  ): Promise<{ orderedLayers: PlaybackLayer[]; hiddenLayerKeys: Set<string> } | null> => {
    const entry = surveyLayerPanelSurveysRef.current.find(
      (e) => e.surveySlug === surveySlug,
    );
    if (!entry) return null;

    const wfsLayers = entry.layers.filter(
      (layer) => selectedLayerKeys.includes(layer.key) && isWfsImageLayer(layer),
    );
    if (wfsLayers.length === 0) return null;

    // Collect map layers to hide later (when the split opens) so we do not
    // blank tiles during the async WFS fetch while the map is still full-width.
    const layerKeysToHide = new Set<string>();
    const layerDataMap = new Map<string, PlaybackLayer>();

    await Promise.all(
      wfsLayers.map(async (layerNode) => {
        let layerRef: ArcGisLayerLike | undefined = geoserverLayerRefs.current[layerNode.key];

        if (layerRef) {
          layerKeysToHide.add(layerNode.key);
        }

        if (!layerRef) {
          // @ts-expect-error ArcGIS modules ship without complete TS types in this project
          const TempGeoJSONLayer = (await import('@arcgis/core/layers/GeoJSONLayer')).default;
          layerRef = new TempGeoJSONLayer({ url: layerNode.endpoint }) as ArcGisLayerLike;
          try {
            await layerRef.load?.();
          } catch {
            return;
          }
        }

        try {
          const result = await layerRef.queryFeatures?.({
            where: '1=1',
            outFields: ['*'],
            returnGeometry: true,
          });
          const features: LayerFeature[] = (result?.features || [])
            .map((f) => ({
              filePath: String(f.attributes?.file_path || ''),
              imageType:
                String(f.attributes?.image_type || '').toUpperCase() === 'PANO'
                  ? ('PANO' as const)
                  : ('STATIC' as const),
              order: Number(f.attributes?.order ?? 0),
              imageIndex: normalizeImageIndex(f.attributes?.image_index),
              spatialIndex: normalizeImageIndex(f.attributes?.spatial_index),
              geometry: (f.geometry as LayerFeatureGeometry | null | undefined) ?? null,
              attributes: (f.attributes || {}) as LayerFeature['attributes'],
            }))
            .filter((f) => !!f.filePath)
            .sort((a, b) => a.order - b.order);

          if (features.length > 0) {
            layerDataMap.set(layerNode.key, {
              layerKey: layerNode.key,
              layerName: layerNode.name,
              surveySlug,
              surveyLabel: entry.displayLabel,
              features,
            });
          }
        } catch {
          // Ignore per-layer errors and continue using successful layers.
        }
      }),
    );

    const orderedLayers = wfsLayers
      .map((layer) => layerDataMap.get(layer.key))
      .filter((layer): layer is PlaybackLayer => layer != null);

    if (orderedLayers.length === 0) {
      return null;
    }

    return {
      orderedLayers,
      hiddenLayerKeys: layerKeysToHide,
    };
  };

  const buildPlaybackLayerLoadCacheKey = (
    surveySlug: string,
    selectedLayerKeys: readonly string[],
  ): string => `${surveySlug}::${selectedLayerKeys.join('|')}`;

  const getSurveyWfsLayerSelectionForDrop = (
    surveySlug: string,
  ): ReturnType<typeof resolvePlaybackWfsLayerSelection> => {
    const entry = surveyLayerPanelSurveysRef.current.find(
      (e) => e.surveySlug === surveySlug,
    );
    if (!entry) {
      return { keys: [], exceedsExplicitCapacity: false };
    }
    return resolvePlaybackWfsLayerSelection(
      entry.layers,
      MAX_SIMULTANEOUS_IMAGES,
    );
  };

  const getSurveyWfsLayerKeysForDrop = (surveySlug: string): string[] =>
    getSurveyWfsLayerSelectionForDrop(surveySlug).keys;

  const prefetchPlaybackLayersForDrop = (surveySlug: string) => {
    const selectedLayerKeys = getSurveyWfsLayerKeysForDrop(surveySlug);
    if (selectedLayerKeys.length === 0) {
      return;
    }
    const cacheKey = buildPlaybackLayerLoadCacheKey(surveySlug, selectedLayerKeys);
    if (playbackLayerLoadPrefetchRef.current?.cacheKey === cacheKey) {
      return;
    }
    playbackLayerLoadPrefetchRef.current = {
      cacheKey,
      promise: loadPlaybackLayersForSurvey(surveySlug, selectedLayerKeys),
    };
  };

  const loadPlaybackLayersForDrop = async (
    surveySlug: string,
    selectedLayerKeys: string[],
  ): Promise<{ orderedLayers: PlaybackLayer[]; hiddenLayerKeys: Set<string> } | null> => {
    const cacheKey = buildPlaybackLayerLoadCacheKey(surveySlug, selectedLayerKeys);
    const prefetched = playbackLayerLoadPrefetchRef.current;
    if (prefetched?.cacheKey === cacheKey) {
      playbackLayerLoadPrefetchRef.current = null;
      return prefetched.promise;
    }
    return loadPlaybackLayersForSurvey(surveySlug, selectedLayerKeys);
  };

  const applyPlaybackHiddenLayers = (nextHiddenKeys: Set<string>) => {
    const previousHiddenKeys = playbackHiddenLayerKeysRef.current;

    previousHiddenKeys.forEach((key) => {
      if (nextHiddenKeys.has(key)) return;
      const layerRef = geoserverLayerRefs.current[key];
      if (layerRef) layerRef.visible = true;
    });

    nextHiddenKeys.forEach((key) => {
      const layerRef = geoserverLayerRefs.current[key];
      if (layerRef && layerRef.visible) {
        layerRef.visible = false;
      }
    });

    playbackHiddenLayerKeysRef.current = nextHiddenKeys;
  };

  const startPlaybackSession = (
    surveySlug: string,
    orderedLayers: PlaybackLayer[],
    hiddenLayerKeys: Set<string>,
    preferredSyncValue: number | null,
    syncMode: SyncMode = 'image',
    focusOwnerLayerKey: string | null = null,
  ): boolean => {
    if (orderedLayers.length > MAX_SIMULTANEOUS_IMAGES) {
      notifyImageViewerCapacityLimit();
      return false;
    }

    // Hide survey WFS layers in the same turn as opening the split, so the map
    // does not flash empty during the earlier feature fetch.
    applyPlaybackHiddenLayers(hiddenLayerKeys);
    setSecondaryIsExpanded(false);
    setIsPlaybackActive(true);
    setActiveSurveySlug(surveySlug);
    setPlaybackLayers(orderedLayers);
    setPlaybackSyncMode(syncMode);
    const validFocusOwner =
      syncMode === 'spatial' && focusOwnerLayerKey
        ? orderedLayers.some((layer) => layer.layerKey === focusOwnerLayerKey)
          ? focusOwnerLayerKey
          : null
        : null;
    setPlaybackFocusOwnerLayerKey(validFocusOwner);
    setPlaybackIndex(
      resolvePlaybackStartPosition(orderedLayers, preferredSyncValue, syncMode),
    );
    setIsPlaybackGridLoading(false);
    setPlaybackFocusMessage(null);
    return true;
  };

  const triggerPlaybackStart = async (
    surveySlug: string,
    selectedLayerKeys: string[],
    preferredImageIndex: number | null = null,
    options?: { readonly exceedsExplicitCapacity?: boolean },
  ) => {
    if (
      options?.exceedsExplicitCapacity ||
      selectedLayerKeys.length > MAX_SIMULTANEOUS_IMAGES
    ) {
      notifyImageViewerCapacityLimit();
      return;
    }

    window.dispatchEvent(new CustomEvent('image-viewer:close-all'));
    setSecondaryIsExpanded(false);
    setPlaybackLoadingSurveySlug(surveySlug);
    playbackPinPreferredLayerKeyRef.current = null;

    // Fetch features while the map stays full-width, then open the split once.
    try {
      const loadedPlayback = await loadPlaybackLayersForSurvey(
        surveySlug,
        selectedLayerKeys,
      );
      if (!loadedPlayback) {
        setPlaybackLoadingSurveySlug(null);
        return;
      }

      startPlaybackSession(
        surveySlug,
        loadedPlayback.orderedLayers,
        loadedPlayback.hiddenLayerKeys,
        preferredImageIndex,
        'image',
        null,
      );
    } finally {
      setPlaybackLoadingSurveySlug(null);
    }
  };

  const handleSurveyImageDropOnMap = async (
    surveySlug: string,
    dropPoint: { x?: number; y?: number; spatialReference?: { wkid?: number } },
  ) => {
    const abortDropLanding = () => {
      dropPinLandingApiRef.current?.abortLanding();
      restoreSurveyHighlightAfterFailedDrop();
    };

    const entry = surveyLayerPanelSurveysRef.current.find(
      (e) => e.surveySlug === surveySlug,
    );
    const selectionDecision = resolvePegmanDropSelection(
      entry?.layers ?? [],
      MAX_SIMULTANEOUS_IMAGES,
    );
    if (selectionDecision.outcome === 'no-wfs-layers') {
      abortDropLanding();
      return;
    }
    if (selectionDecision.outcome === 'capacity-limit') {
      notifyImageViewerCapacityLimit();
      abortDropLanding();
      return;
    }
    const selectedLayerKeys = selectionDecision.selection.keys;

    setPlaybackLoadingSurveySlug(surveySlug);
    try {
      const loadedPlayback = await loadPlaybackLayersForDrop(
        surveySlug,
        selectedLayerKeys,
      );
      if (!loadedPlayback) {
        abortDropLanding();
        return;
      }

      // Corridor drop already validated proximity. Snap to nearest image even when
      // image spacing exceeds the zoom-scaled drop radius
      const nearestDecision = resolvePegmanNearestImageForPlayback(
        loadedPlayback.orderedLayers,
        dropPoint,
      );
      if (nearestDecision.outcome === 'no-nearest-image') {
        abortDropLanding();
        return;
      }
      const {
        nearestImageIndex,
        nearestSpatialIndex,
        nearestLayerKey,
        nearestPoint,
      } = nearestDecision;

      window.dispatchEvent(new CustomEvent('image-viewer:close-all'));

      dropPinLandingApiRef.current?.suppressForMapFall();

      const preservedMode: SyncMode = isPlaybackActiveRef.current
        ? playbackSyncModeRef.current
        : 'image';
      const preservedFocusOwnerLayerKey =
        preservedMode === 'spatial' ? playbackFocusOwnerLayerKeyRef.current : null;
      const preferredSyncValue =
        preservedMode === 'spatial' ? nearestSpatialIndex : nearestImageIndex;

      playbackPinPreferredLayerKeyRef.current = nearestLayerKey;
      playbackPinSuppressedRef.current = true;
      playbackPinExactPointRef.current = {
        x: nearestPoint.x,
        y: nearestPoint.y,
        spatialReference: nearestPoint.spatialReference,
      };

      const playbackStarted = startPlaybackSession(
        surveySlug,
        loadedPlayback.orderedLayers,
        loadedPlayback.hiddenLayerKeys,
        preferredSyncValue,
        preservedMode,
        preservedFocusOwnerLayerKey,
      );
      if (!playbackStarted) {
        abortDropLanding();
        return;
      }

      const prefersReducedMotion =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let dismissFallOverlay: (() => Promise<void>) | null = null;
      let pinRevealed = false;

      try {
        await Promise.all([
          waitForPlaybackSplitReady(),
          preloadDropPinImage(dropPinIconUrl),
        ]);

        const targetPinPoint: PlaybackPinPoint = {
          x: nearestPoint.x,
          y: nearestPoint.y,
          spatialReference: nearestPoint.spatialReference,
        };
        const spatialReference =
          nearestPoint.spatialReference ??
          view?.spatialReference ??
          { wkid: 3857 };

        if (view) {
          const extent = view.extent as
            | {
                xmin: number;
                ymin: number;
                xmax: number;
                ymax: number;
              }
            | undefined;
          const needsRecenter =
            !extent ||
            isMapPointOutsidePaddedExtent(
              { x: targetPinPoint.x, y: targetPinPoint.y },
              extent,
            );

          const targetPoint = new Point({
            x: targetPinPoint.x,
            y: targetPinPoint.y,
            spatialReference,
          });

          if (needsRecenter && typeof view.goTo === 'function') {
            try {
              await Promise.resolve(
                view.goTo(
                  { target: targetPoint },
                  {
                    duration: prefersReducedMotion
                      ? 0
                      : DROP_PIN_RECENTER_DURATION_MS,
                    easing: 'ease-in-out',
                  },
                ),
              );
            } catch {
              // Fall still runs at the best-known position.
            }
          }

          await waitForDropMapSettled(view);

          if (playbackPinRef.current) {
            try {
              view.graphics.remove(playbackPinRef.current);
            } catch {
              // ignore
            }
            playbackPinRef.current = null;
          }

        
          const mapPin = new Graphic({
            geometry: targetPoint,
            symbol: new PictureMarkerSymbol({
              url: dropPinIconUrl,
              width: '24px',
              height: '36px',
              yoffset: 18,
            }),
            visible: false,
          });
          view.graphics.add(mapPin);
          playbackPinRef.current = mapPin;
          
          playbackPinExactPointRef.current = {
            x: targetPinPoint.x,
            y: targetPinPoint.y,
            spatialReference,
          };
          playbackPinHandoffActiveRef.current = true;
          playbackPinSkipNextRecenterRef.current = true;
          playbackPinSuppressedRef.current = false;

          if (typeof view.toScreen === 'function') {
            const screen = view.toScreen(targetPoint) as
              | { x?: number; y?: number }
              | null
              | undefined;
            const mapEl = view.container as HTMLElement | null | undefined;
            if (
              screen &&
              mapEl &&
              typeof screen.x === 'number' &&
              typeof screen.y === 'number' &&
              Number.isFinite(screen.x) &&
              Number.isFinite(screen.y)
            ) {
              const rect = mapEl.getBoundingClientRect();
              const fallHandle = await runDropPinFallOverlay({
                clientX: rect.left + screen.x,
                clientY: rect.top + screen.y,
                iconUrl: dropPinIconUrl,
                prefersReducedMotion,
              });
              dismissFallOverlay = fallHandle.dismiss;
            }
          }

          const dismissFall = dismissFallOverlay;
          dismissFallOverlay = null;
          await completeDropPinFallToMapPin({
            dismissFall,
            revealMapPin: () => {
              mapPin.visible = true;
            },
            whileCovered: async () => {
              setPlaybackLoadingSurveySlug(null);
              await restoreDropPinSourceButton(() => {
                dropPinLandingApiRef.current?.releaseSource();
              });
            },
          });
          playbackPinLockedSyncValueRef.current = currentPlaybackSyncValue;
          playbackPinSkipNextEffectRef.current = true;
          playbackPinHandoffActiveRef.current = false;
          pinRevealed = true;
        }
      } finally {
        if (!pinRevealed) {
          playbackPinHandoffActiveRef.current = false;
          playbackPinSuppressedRef.current = false;
          playbackPinSkipNextEffectRef.current = false;
          playbackPinLockedSyncValueRef.current = null;
          dropPinLandingApiRef.current?.releaseSource();
        }
        if (dismissFallOverlay) {
          void dismissFallOverlay();
        }
      }

      pendingDragHighlightRestoreRef.current = null;
    } finally {
      setPlaybackLoadingSurveySlug(null);
    }
  };

  const handleSurveyImageDropOnMapRef = useRef(handleSurveyImageDropOnMap);
  handleSurveyImageDropOnMapRef.current = handleSurveyImageDropOnMap;

  useEffect(() => {
    if (!view?.container) return;

    const mapContainer = view.container as HTMLDivElement;
    let cachedBounds = mapContainer.getBoundingClientRect();
    let prefetchStartedForSlug: string | null = null;
    let lastHit: ScreenHitSample | null = null;
    let pendingClientX = 0;
    let pendingClientY = 0;
    let pendingSlug: string | null = null;
    let hitTestRafId: number | null = null;
    let cachedMaxDistance = resolveMaxDropDistanceMeters({
      zoom: typeof view.zoom === 'number' ? view.zoom : null,
      resolution: typeof view.resolution === 'number' ? view.resolution : null,
    });

    const refreshBounds = () => {
      cachedBounds = mapContainer.getBoundingClientRect();
      lastHit = null;
    };

    const refreshZoomDistance = () => {
      cachedMaxDistance = resolveMaxDropDistanceMeters({
        zoom: typeof view.zoom === 'number' ? view.zoom : null,
        resolution:
          typeof view.resolution === 'number' ? view.resolution : null,
      });
      lastHit = null;
    };

    const setDropAllowedUi = (allowed: boolean) => {
      const next = allowed ? '1' : '0';
      if (document.documentElement.dataset.xaSurveyDropAllowed !== next) {
        document.documentElement.dataset.xaSurveyDropAllowed = next;
      }
    };

    const applyDropCursor = (event: DragEvent, allowed: boolean) => {
      if (!event.dataTransfer) {
        return;
      }
      if (allowed) {
        // Required synchronously so the browser keeps the drop target active.
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
      } else {
        // Disabled / not-allowed cursor outside the droppable radius.
        event.dataTransfer.dropEffect = 'none';
      }
      setDropAllowedUi(allowed);
    };

    const measureDistanceMeters = (
      from: { readonly x?: number; readonly y?: number },
      geometry: unknown,
    ): number | null => {
      try {
        const measured = geometryEngine.distance(from, geometry, 'meters') as number;
        return typeof measured === 'number' && Number.isFinite(measured)
          ? measured
          : null;
      } catch {
        return null;
      }
    };

    const runHitTest = (clientX: number, clientY: number, surveySlug: string) => {
      const mapPoint = view.toMap({
        x: clientX - cachedBounds.left,
        y: clientY - cachedBounds.top,
      });
      const allowed = Boolean(
        mapPoint &&
          isMapPointOnHighlightedSurvey(
            mapPoint,
            surveySlug,
            highlightedSurveyDropGeometriesRef.current,
            measureDistanceMeters,
            cachedMaxDistance,
          ),
      );
      lastHit = { clientX, clientY, surveySlug, allowed };
      setDropAllowedUi(allowed);
      if (allowed && prefetchStartedForSlug !== surveySlug) {
        prefetchStartedForSlug = surveySlug;
        prefetchPlaybackLayersForDrop(surveySlug);
      }
      return allowed;
    };

    const handleDragOver = (event: DragEvent) => {
      if (
        !isSurveyImageDragMimePresent(
          event.dataTransfer?.types,
          SURVEY_IMAGE_DRAG_MIME,
        )
      ) {
        return;
      }

      const surveySlug = surveyImageDragSlugRef.current;
      const cache = highlightedSurveyDropGeometriesRef.current;
      if (
        !surveySlug ||
        cache?.slug !== surveySlug ||
        cache.geometries.length === 0
      ) {
        applyDropCursor(event, false);
        return;
      }

      if (
        shouldReuseSurveyDragHit(
          lastHit,
          event.clientX,
          event.clientY,
          surveySlug,
        )
      ) {
        applyDropCursor(event, lastHit!.allowed);
        return;
      }

      // Keep the last known cursor until the coalesced hit-test finishes.
      applyDropCursor(event, lastHit?.surveySlug === surveySlug ? lastHit.allowed : false);

      pendingClientX = event.clientX;
      pendingClientY = event.clientY;
      pendingSlug = surveySlug;
      if (hitTestRafId != null) {
        return;
      }
      hitTestRafId = window.requestAnimationFrame(() => {
        hitTestRafId = null;
        const slug = pendingSlug;
        if (!slug) {
          return;
        }
        runHitTest(pendingClientX, pendingClientY, slug);
      });
    };

    const handleDrop = (event: DragEvent) => {
      const surveySlug = event.dataTransfer?.getData(SURVEY_IMAGE_DRAG_MIME);
      if (!surveySlug) return;

      refreshBounds();
      const mapPoint = view.toMap({
        x: event.clientX - cachedBounds.left,
        y: event.clientY - cachedBounds.top,
      });

      if (
        !mapPoint ||
        !isMapPointOnHighlightedSurvey(
          mapPoint,
          surveySlug,
          highlightedSurveyDropGeometriesRef.current,
          measureDistanceMeters,
          resolveMaxDropDistanceMeters({
            zoom: typeof view.zoom === 'number' ? view.zoom : null,
            resolution:
              typeof view.resolution === 'number' ? view.resolution : null,
          }),
        )
      ) {
        applyDropCursor(event, false);
        return;
      }

      event.preventDefault();
      surveyDragDropReceivedRef.current = true;
      prefetchStartedForSlug = null;
      lastHit = null;
      setDropAllowedUi(false);
      if (playbackPinRef.current) {
        try {
          view.graphics.remove(playbackPinRef.current);
        } catch {
          // ignore
        }
        playbackPinRef.current = null;
      }
      setPlaybackLoadingSurveySlug(surveySlug);

      prefetchPlaybackLayersForDrop(surveySlug);
      void handleSurveyImageDropOnMapRef.current(surveySlug, mapPoint);
    };

    const handleDragLeave = (event: DragEvent) => {
      // Only clear when leaving the map surface itself (not child bubbling).
      if (event.target !== mapContainer) {
        return;
      }
      lastHit = null;
      setDropAllowedUi(false);
    };

    mapContainer.addEventListener('dragover', handleDragOver);
    mapContainer.addEventListener('drop', handleDrop);
    mapContainer.addEventListener('dragleave', handleDragLeave);
    window.addEventListener('resize', refreshBounds, { passive: true });
    window.addEventListener('scroll', refreshBounds, {
      passive: true,
      capture: true,
    });
    const zoomHandle = reactiveUtils.watch(() => view.zoom, refreshZoomDistance);
    const resolutionHandle = reactiveUtils.watch(
      () => view.resolution,
      refreshZoomDistance,
    );

    return () => {
      mapContainer.removeEventListener('dragover', handleDragOver);
      mapContainer.removeEventListener('drop', handleDrop);
      mapContainer.removeEventListener('dragleave', handleDragLeave);
      window.removeEventListener('resize', refreshBounds);
      window.removeEventListener('scroll', refreshBounds, true);
      if (hitTestRafId != null) {
        window.cancelAnimationFrame(hitTestRafId);
      }
      zoomHandle.remove();
      resolutionHandle.remove();
      delete document.documentElement.dataset.xaSurveyDropAllowed;
    };
  }, [view]);

  const handlePlaySurvey = (surveySlug: string) => {
    const entry = surveyLayerPanelSurveysRef.current.find(
      (e) => e.surveySlug === surveySlug,
    );
    const decision = resolvePlaySurveyClick({
      surveySlug,
      activeSurveySlug,
      panelLayers: entry?.layers ?? null,
      maxSimultaneousImages: MAX_SIMULTANEOUS_IMAGES,
    });

    if (decision.outcome === 'stop-playback') {
      handleStopPlayback();
      return;
    }
    if (
      decision.outcome === 'survey-not-found' ||
      decision.outcome === 'no-wfs-layers'
    ) {
      return;
    }
    if (decision.outcome === 'capacity-limit') {
      notifyImageViewerCapacityLimit();
      return;
    }

    setHighlightedPanelSurveySlug(surveySlug);
    void triggerPlaybackStart(surveySlug, decision.selection.keys, null, {
      exceedsExplicitCapacity: decision.selection.exceedsExplicitCapacity,
    });
  };

  const handlePlaybackNavigate = (
    direction: 'next' | 'previous' | 'first' | 'last',
  ) => {
    setPlaybackFocusMessage(null);
    setPlaybackIndex((prev) => {
      const maxIdx = Math.max(playbackTimelineSyncValues.length - 1, 0);
      if (direction === 'first') return 0;
      if (direction === 'last') return maxIdx;
      return direction === 'next'
        ? Math.min(prev + 1, maxIdx)
        : Math.max(prev - 1, 0);
    });
  };

  const handlePlaybackSetSyncModeFromFeature = (
    layerKey: string,
    feature: LayerFeature,
    mode: SyncMode,
  ) => {
    const decision = resolvePlaybackSyncModeChange(
      playbackLayers,
      feature,
      layerKey,
      mode,
    );
    if (!decision.ok) {
      setPlaybackFocusMessage(decision.message);
      return;
    }

    setPlaybackFocusMessage(null);
    setPlaybackSyncMode(decision.mode);
    setPlaybackFocusOwnerLayerKey(decision.focusOwnerLayerKey);
    setPlaybackIndex(decision.nextIndex);
  };

  const handlePlaybackPanoramaStateChange = (
    _layerKey: string,
    _state: PanoramaState | null,
  ) => {
    // Panorama view state is owned by PlaybackViewerCard; Dashboard does not sync it yet
  };

  const handleSurveyLayerGoToStart = async (layerKey: string) => {
    const entry = surveyLayerPanelSurveysRef.current.find((e) =>
      e.layers.some((l) => l.key === layerKey),
    );
    if (!entry) return;
    const layerNode = entry.layers.find((l) => l.key === layerKey);
    const layerRef = geoserverLayerRefs.current[layerKey];
    if (!layerRef?.queryFeatures) return;

    let layerFeatures: LayerFeature[] = [];
    try {
      const result = await layerRef.queryFeatures({
        where: '1=1',
        outFields: ['*'],
        returnGeometry: true,
      });
      layerFeatures = (result?.features || [])
        .map((f) => ({
          filePath: String(f.attributes?.file_path || ''),
          imageType:
            String(f.attributes?.image_type || '').toUpperCase() === 'PANO'
              ? ('PANO' as const)
              : ('STATIC' as const),
          order: Number(f.attributes?.order ?? 0),
          imageIndex: normalizeImageIndex(f.attributes?.image_index),
          spatialIndex: normalizeImageIndex(f.attributes?.spatial_index),
          geometry: (f.geometry as LayerFeatureGeometry | null | undefined) ?? null,
          attributes: (f.attributes || {}) as LayerFeature['attributes'],
        }))
        .sort((a, b) => a.order - b.order);
    } catch {
      return;
    }

    if (!layerFeatures.length) return;
    const first = layerFeatures[0];

    window.dispatchEvent(
      new CustomEvent('image-viewer:open', {
        detail: {
          surveySlug: entry.surveySlug,
          surveyLabel: entry.displayLabel,
          layerKey,
          layerName: layerNode?.name || layerKey,
          layerRef,
          filePath: first.filePath,
          imageType: first.imageType,
          geometry: first.geometry,
          featureIndex: 0,
          layerFeatures,
        } as OpenViewerParams,
      }),
    );
  };

  /**
   * Handle a click on a WFS survey data-point. Opens (or jumps) the image viewer
   */
  const handleWfsSurveyPointClick = async (clickedGraphic: ArcGisGraphicLike) => {
    if (isPlaybackActive) return;

    const attrs = clickedGraphic.attributes || {};

    const imageType: 'STATIC' | 'PANO' = String(attrs.image_type || '').toUpperCase() === 'PANO' ? 'PANO' : 'STATIC';
    let filePath: string = String(attrs.file_path || '');
    const surveySlug: string = String(attrs.survey_slug || '');

    // Identify which layer key this graphic belongs to
    const clickedLayer = clickedGraphic.layer;
    let matchedLayerKey = '';
    let matchedLayerName = '';
    let matchedSurveyLabel = '';

    for (const [key, ref] of Object.entries(geoserverLayerRefs.current)) {
      if (ref === clickedLayer) {
        matchedLayerKey = key;
        break;
      }
    }

    // Find the survey entry and layer from the panel state.
    // Use the ref so we always read the current value even inside the stale click-event closure
    const entry = surveyLayerPanelSurveysRef.current.find((e) =>
      e.layers.some((l) => l.key === matchedLayerKey),
    );
    if (entry) {
      matchedSurveyLabel = entry.displayLabel;
      const layerNode = entry.layers.find((l) => l.key === matchedLayerKey);
      if (layerNode) matchedLayerName = layerNode.name;
    }

    if (!matchedLayerKey) return;
    if (!filePath) return;

    // Query all features from this layer and order by the 'order' field
    let layerFeatures: LayerFeature[] = [];
    try {
      const result = await clickedLayer?.queryFeatures?.({
        where: '1=1',
        outFields: ['*'],
        returnGeometry: true,
      });
      const features: LayerFeature[] = (result?.features || []).map((f: ArcGisGraphicLike) => ({
        filePath: String(f.attributes?.file_path || ''),
        imageType:
          String(f.attributes?.image_type || '').toUpperCase() === 'PANO'
            ? 'PANO'
            : 'STATIC',
        order: Number(f.attributes?.order ?? 0),
        imageIndex: readOptionalNumericAttribute(f.attributes, 'image_index'),
        spatialIndex: readOptionalNumericAttribute(f.attributes, 'spatial_index'),
        geometry: (f.geometry as LayerFeatureGeometry | null | undefined) ?? null,
        attributes: (f.attributes || {}) as LayerFeature['attributes'],
      }));

      layerFeatures = features.sort((a, b) => a.order - b.order);
    } catch {
      // If query fails, build a single-item list from the clicked graphic
      layerFeatures = [
        {
          filePath,
          imageType,
          order: 0,
          imageIndex: readOptionalNumericAttribute(attrs, 'image_index'),
          spatialIndex: readOptionalNumericAttribute(attrs, 'spatial_index'),
          geometry: (clickedGraphic.geometry as LayerFeatureGeometry | null | undefined) ?? null,
          attributes: (attrs || {}) as LayerFeature['attributes'],
        },
      ];
    }

    // Find the index of the clicked feature
    const featureIndex = layerFeatures.findIndex((f) => f.filePath === filePath);
    const safeFeatureIndex = featureIndex >= 0 ? featureIndex : 0;

    // Ensure filePath matches the active feature we open on
    const active = layerFeatures[safeFeatureIndex];
    if (active) {
      filePath = active.filePath;
    }

    // Dispatch a custom event that the ImageViewerProvider will listen for.
    window.dispatchEvent(
      new CustomEvent('image-viewer:open', {
        detail: {
          surveySlug,
          surveyLabel: matchedSurveyLabel || surveySlug,
          layerKey: matchedLayerKey,
          layerName: matchedLayerName || matchedLayerKey,
          layerRef: clickedLayer,
          filePath,
          imageType,
          geometry: clickedGraphic.geometry,
          featureIndex: safeFeatureIndex,
          layerFeatures,
          autoPan: false,
        } as OpenViewerParams,
      }),
    );
  };

  const clearSearchHighlights = useCallback(() => {
    if (highlight) {
      highlight.remove();
      highlight = null;
    }
  }, []);

  const highlightSearchResults = useCallback(
    async (items: readonly string[], layerKey: string) => {
      if (!view) {
        clearSearchHighlights();
        return;
      }

      await applySearchResultHighlights({
        items,
        layer: toQueryableAssetLayer(layerData[layerKey]),
        clearHighlight: clearSearchHighlights,
        highlightGraphics: async (_layer, graphics) => {
          const layer = layerData[layerKey];
          if (!layer) {
            return;
          }

          await view.whenLayerView(layer).then((layerView: ArcGisLayerViewLike) => {
            if (highlight) {
              highlight.remove();
            }
            highlight = layerView.highlight(graphics);
          });
        },
      });
    },
    [view, layerData, clearSearchHighlights],
  );

  const handleSearchResultsChange = useCallback(
    (items: string[]) => {
      const action = resolveSearchResultsHighlightAction(searchContent, items);
      if (action.kind === 'highlight') {
        void highlightSearchResults(action.items, action.layerKey);
        if (action.autoSelectItem) {
          onSelectNode({ ...searchContent, selectedItem: action.autoSelectItem });
        }
        return;
      }

      clearSearchHighlights();
    },
    [searchContent, highlightSearchResults, clearSearchHighlights],
  );

  const searchCurrentLayer = useCallback(
    async (keyword: string): Promise<string[]> => {
      if (!keyword?.trim()) {
        return [];
      }

      const layerKey =
        searchContent.type === 'current-layer' ? searchContent.selectedKey : null;
      const endPoint = searchContent.selectedEndPoint;
      if (!layerKey && !endPoint) {
        return [];
      }

      const layer = layerKey ? toQueryableAssetLayer(layerData[layerKey]) : null;
      const resolveGeoJsonUrl = (): string | null => {
        if (!endPoint) {
          return null;
        }
        if (endPoint.startsWith('http://') || endPoint.startsWith('https://')) {
          return endPoint;
        }
        return `${process.env.REACT_APP_API_URL}/${endPoint}`;
      };

      const fetchGeoJson = resolveGeoJsonUrl()
        ? async () =>
            (await fetchGeoJsonWithRefresh(resolveGeoJsonUrl() as string)) as {
              features?: Array<{
                properties?: Record<string, unknown>;
                attributes?: Record<string, unknown>;
              }>;
            }
        : undefined;

      return searchCurrentLayerAssetLabels({
        keyword,
        layerKey: layerKey ?? null,
        layer,
        fetchGeoJson,
        searchAssets: async (searchKeyword, assetTypeCode) => {
          const response = await searchActions().searchAssets(
            searchKeyword,
            assetTypeCode,
            1,
            25,
          );
          return response.results;
        },
      });
    },
    [
      layerData,
      searchContent.type,
      searchContent.selectedKey,
      searchContent.selectedEndPoint,
    ],
  );

  const onSelectSearchDetailsType = (type: string) => {
    if (type === 'network') {
      setSearchContent({
        ...searchContent,
        type: 'network',
        selectedKey: 'network-layer',
        selectedLabel: 'Network',
        selectedCategory: 'Network',
        selectedEndPoint: undefined,
      });
    } else if (type === 'current-layer') {
      if (selectedNode !== null) {
        setSearchContent({
          ...searchContent,
          type: 'current-layer',
          selectedKey: selectedNode.key,
          selectedLabel: selectedNode.title ?? selectedNode.key,
          selectedCategory: selectedNode.category,
          selectedEndPoint: selectedNode.endPoint,
        });
      }
    }
  };

  const isNodeSelected = () => {
    return selectedNode !== null;
  };

  const onSelectSearchDetailsItem = (item: string) => {
    const newSearchContent = { ...searchContent, selectedItem: item };
    setSearchContent(newSearchContent);
    onSelectNode(newSearchContent);
  };

  const onAction = async (
    title: string,
    refreshLegendToolbar: boolean = false,
  ) => {
    if (title === 'Measure') {
      setActionsState((prevState) => ({
        ...prevState,
        [title]: !prevState[title],
      }));
      if (
        measurementWidget.current !== null &&
        measurementWidget.current.isResolved()
      ) {
        measurementWidget.current.destroy();
        measurementWidget.current = null;
      } else {
        measurementWidget.current = new Measurement({
          view: view,
          activeTool: 'distance',
        });
        view.ui.add(measurementWidget.current, 'bottom-right');
        measurementWidget.current.startMeasurement();
      }
    } else if (title === 'Legend' && !refreshLegendToolbar) {
      setModalState((prevState) => ({
        ...prevState,
        Legend: !prevState['Legend'],
      }));
      setActionsState((prevState) => ({
        ...prevState,
        Legend: !prevState['Legend'],
      }));
    } else if (title === 'Basemaps') {
      setModalState((prevState) => ({
        ...prevState,
        Basemaps: !prevState['Basemaps'],
      }));
      setActionsState((prevState) => ({
        ...prevState,
        Basemaps: !prevState['Basemaps'],
      }));
    }
  };

  const zoomToSection = (key: string) => {
    if (layerData[key] && view) {
      stopMapViewAnimation(view);
      void view.goTo(layerData[key].fullExtent).catch(() => {});
    }
  };

  useEffect(() => {
    setPrimaryIsExpanded(false);
  }, []);

  useEffect(() => {
    const findInterceptor = esriConfig.request.interceptors?.find(
      (interceptor: { urls: string | string[] }) =>
        interceptor.urls.includes('https://api.emapsite.com/'),
    );
    if (!findInterceptor) {
      esriConfig.request.interceptors.push({
        urls: ['https://api.emapsite.com/'],
        before: () => {
          setRequestMade((prev) => prev + 1);
        },
      });
    }
  }, []);

  useEffect(() => {
    let tileRequests = 0;
    tileRequests += requestMade;
    const sendDataToAzureApplicationInsight = () => {
      if (tileRequests > 0) {
        const tenant = localStorage.getItem('tenantId')?.replace(/['"]+/g, '');
        appInsights.trackEvent({
          name: 'CustomEvent',
          properties: { tileRequests, service: 'emapsite', tenant },
        });
        setRequestMade(0);
      }
    };
    sendDataToAzureApplicationInsight();

    return () => {
      tileRequests = 0;
    };
  }, [requestMade]);

  const computeStyle = (style: SymbologyModel, type: string) => {
    let st = {
      color: style.currentColor,
      size: `${style.currentSize}px`,
      width: `${style.currentWidth}px`,
      style: style.style,
      outline: {},
      currentStyle: `symbols-sls-${style.style}`,
      type: type,
      angle: style.currentAngle,
      currentWidth: style.currentWidth,
      currentSize: style.currentSize,
      // currentLineStyle: 'solid',
      // currentMarkerStyle: 'circle',
      currentColor: style.currentColor,
      currentAngle: style.currentAngle,
    };

    if (
      style.currentMarkerStyle === 'cross' ||
      style.currentMarkerStyle === 'x'
    ) {
      st.outline = {
        width: 6,
        color: style.currentColor,
      };
    }

    if (style.currentLineStyle && type === 'simple-line') {
      st.style = style.currentLineStyle;
      st.currentStyle = `symbols-sls-${style.currentLineStyle}`;
    }
    if (style.currentMarkerStyle && type === 'simple-marker') {
      st.style = style.currentMarkerStyle;
      st.currentStyle = `symbols-sls-${style.currentMarkerStyle}`;
    }
    return st;
  };

  const composeValueExpression = (
    layerAttributeStyles: LayerAttributeStyle[],
  ) => {
    if (layerAttributeStyles.length === 0) {
      return '';
    }
    let composedResult = 'When(';

    layerAttributeStyles.forEach((element) => {
      if (element.dataType === 'Integer') {
        let ruleName = `$feature.${element.name.replaceAll(' ', '_')} ${element.firstComparison?.value} ${element.firstValue}`;
        if (
          element?.ruleChaining?.label &&
          element?.secondComparison?.label &&
          element?.secondValue
        ) {
          ruleName += `${element.ruleChaining.value === 'Or' ? ' ||' : ' &&'} $feature.${element.name.replaceAll(' ', '_')} ${element.secondComparison?.value} ${element.secondValue}`;
        }
        composedResult += `${ruleName}, '${getRuleName(element)}', `;
      } else {
        composedResult += `$feature.${element.name.replaceAll(' ', '_')} == '${element.value}', '${element.name}-${element.value}', `;
      }
    });

    composedResult += `'other')`;
    return composedResult;
  };

  const getRuleName = (la: LayerAttributeStyle): string => {
    if (la?.dataType === 'Integer') {
      let ruleName = `${la.name} ${la.firstComparison?.value} ${la.firstValue}`;
      if (
        la?.ruleChaining?.label &&
        la?.secondComparison?.label &&
        la?.secondValue
      ) {
        ruleName += `${la.ruleChaining.value === 'Or' ? ' Or' : ' And'} ${la.secondComparison?.value} ${la.secondValue}`;
      }
      return ruleName;
    }
    return la.name;
  };

  const setLayerVisualisationRules = (
    key: string,
    type: string,
    style: SymbologyModel,
    layerAttributeStyles: LayerAttributeStyle[],
  ) => {
    let url = String(layerData[key]?.url || '');
    if (url.startsWith('blob:')) {
      const rulesUrl = layerRulesStyles[key]?.url;
      if (typeof rulesUrl === 'string' && !rulesUrl.startsWith('blob:')) {
        url = rulesUrl;
      } else {
        const node = checkedNodesState.find((n: LayerListNode) => n.key === key);
        url = node?.endPoint
          ? `${process.env.REACT_APP_API_URL}/${node.endPoint}`
          : '';
      }
    }
    url = url.split('?attributes=')[0];

    let renderer: MutableUnknownRecord = {
      defaultSymbol: {},
    };

    renderer.type = 'unique-value';
    const st = computeStyle(style, type);
    renderer.defaultSymbol = st;

    updateStyle(key, {
      ...st,
      type: type,
    });

    renderer.valueExpression = composeValueExpression(layerAttributeStyles);

    const uniqueStyles = layerAttributeStyles.map((layerAttrybuteStyle) => ({
      name: layerAttrybuteStyle.name,
      label: getRuleName(layerAttrybuteStyle),
      dataType: layerAttrybuteStyle.dataType,
      value: layerAttrybuteStyle.value,
      style: computeStyle(layerAttrybuteStyle.uniqueStyle, type) as unknown as SymbologyModel,
      firstComparison: layerAttrybuteStyle.firstComparison,
      secondComparison: layerAttrybuteStyle.secondComparison,
      ruleChaining: layerAttrybuteStyle.ruleChaining,
      firstValue: layerAttrybuteStyle.firstValue,
      secondValue: layerAttrybuteStyle.secondValue,
    }));

    const newUrl = `${url}?${[...new Set(layerAttributeStyles.map((m) => `attributes=${m.name}`))].join('&')}`;

    updateLayerRulesStyle(key, newUrl, String(renderer.valueExpression || ''), uniqueStyles);

    renderer.uniqueValueInfos = uniqueStyles.map((us) => ({
      value: us.dataType === 'Integer' ? us.label : `${us.name}-${us.value}`,
      symbol: { ...us.style },
    }));

    const geoj = new GeoJSONLayer({
      id: key,
      url: newUrl,
      popupEnabled: false,
      renderer: renderer,
      spatialReference: { wkid: 3857 },
      outFields: ['*'],
    });

    if (layerData[key].geometryType === 'point') {
      geoj.featureReduction = user?.clustering === true ? clusterConfig : null;
      if (geoj.featureReduction) {
        geoj.featureReduction.symbol = {
          type: 'simple-marker',
          color: layersStyle[key].currentColor,
        };
      }
    }
    stopMapViewAnimation(view);
    view.map.layers.removeMany([layerData[key]]);
    view.map.layers.addMany([geoj]);
    setLayerData({
      ...layerData,
      [key]: geoj,
    });
  };

  const setLayerStyle = (
    key: string,
    color: RgbaColor,
    width: number,
    size: number,
    lineStyle: string,
    markerStyle: string,
    angle: number,
  ) => {
    const renderer = layerData[key]?.renderer ?? {};
    let symbol = (
      renderer.type === 'unique-value'
        ? renderer.defaultSymbol
        : renderer.symbol
    ) as MutableUnknownRecord;

    if (symbol?.type === 'cim') {
      const rebuilt = buildSurveyTravelDirectionSymbol(
        {
          ...symbol,
          color,
          currentColor: color,
          width: `${width}px`,
          currentWidth: width,
          size: `${size}px`,
          currentSize: size,
          angle,
          currentAngle: angle,
        },
        view?.zoom ?? 0,
      );
      if (renderer.type === 'unique-value') {
        renderer.defaultSymbol = rebuilt;
      } else {
        renderer.symbol = rebuilt;
      }
      symbol = rebuilt as MutableUnknownRecord;
    } else {
      symbol.color = color;
      applyTravelDirectionArrowColor(symbol, color);
      symbol.width = `${width}px`;
      symbol.size = `${size}px`;

      if (markerStyle === 'cross' || markerStyle === 'x') {
        symbol.outline = {
          width: 6,
          color: color,
        };
      }

      if (lineStyle?.length > 0 && symbol.type === 'simple-line') {
        symbol.style = lineStyle;
      }
      if (markerStyle?.length > 0 && symbol.type === 'simple-marker') {
        symbol.style = markerStyle;
      }
      symbol.angle = angle;
    }

    updateStyle(key, {
      color: color,
      currentColor: color,
      width: `${width}px`,
      currentWidth: width,
      size: `${size}px`,
      currentSize: size,
      style: String(symbol.style || ''),
      currentLineStyle: String(symbol.style || ''),
      currentMarkerStyle: String(symbol.style || ''),
      currentStyle: `symbols-sls-${String(symbol.style || '')}`,
      angle: angle,
      currentAngle: angle,
      type: String(symbol.type || ''),
    });
  };

  const setSurveyLayerStyle = (
    key: string,
    color: RgbaColor,
    width: number,
    size: number,
    lineStyle: string,
    markerStyle: string,
    angle: number,
  ) => {
    const geoLayer = geoserverLayerRefs.current[key];
    if (geoLayer) {
      const renderer = geoLayer.renderer?.clone
        ? (geoLayer.renderer.clone() as ArcGisRendererLike)
        : geoLayer.renderer;
      const symbol =
        renderer?.type === 'unique-value'
          ? renderer.defaultSymbol
          : renderer?.symbol;
        if (symbol) {
        symbol.color = color;
        if (width != null) symbol.width = `${width}px`;
        if (size != null) {
          // Persist slider value as the base size at the reference zoom; draw zoom-scaled px.
          symbol.size =
            symbol.type === 'simple-marker'
              ? `${resolveSurveyWfsPointSizePx(view?.zoom ?? 0, size)}px`
              : `${size}px`;
        }
        if (markerStyle === 'cross' || markerStyle === 'x') {
          symbol.outline = {
            width: 6,
            color,
          };
        } else if (symbol.type === 'simple-marker') {
          symbol.outline = {
            width: 1,
            color: { r: 0, g: 0, b: 0, a: 1 },
          };
        }
        if (lineStyle?.length > 0 && symbol.type === 'simple-line') {
          symbol.style = lineStyle;
        }
        if (markerStyle?.length > 0 && symbol.type === 'simple-marker') {
          symbol.style = markerStyle;
        }
        symbol.angle = angle;
        geoLayer.renderer = renderer;
      }
      void updateStyle(key, {
        color,
        currentColor: color,
        width: `${width}px`,
        currentWidth: width,
        size: `${size}px`,
        currentSize: size,
        style: symbol?.style != null ? String(symbol.style) : undefined,
        currentLineStyle: symbol?.style != null ? String(symbol.style) : undefined,
        currentMarkerStyle: symbol?.style != null ? String(symbol.style) : undefined,
        currentStyle:
          symbol?.style != null ? `symbols-sls-${String(symbol.style)}` : undefined,
        angle,
        currentAngle: angle,
        type: symbol?.type != null ? String(symbol.type) : undefined,
      });
    } else {
      setLayerStyle(key, color, width, size, lineStyle, markerStyle, angle);
    }
    const cssColor = toCssRgbaColor(color);
    setSurveyLayerPanelSurveys((prev) =>
      prev.map((entry) => ({
        ...entry,
        layers: entry.layers.map((layer) =>
          layer.key === key ? { ...layer, color: cssColor } : layer,
        ),
      })),
    );
  };

  const settleNetworkLayerOverlay = async (
    mapView: View,
    layer: ArcGisLayerLike,
    zoomToExtent: boolean = false,
  ): Promise<void> => {
    try {
      await waitForNetworkLayerPaintReady(mapView, layer);
      if (zoomToExtent) {
        const extent = layer.fullExtent;
        if (extent) {
          stopMapViewAnimation(mapView);
          try {
            await mapView.goTo(extent, { animate: false });
          } catch {
            // ignore goTo cancellation
          }
        }
      }
      await waitForMapViewSettled(mapView);
      await waitForNetworkLayerPaintReady(mapView, layer);
      setLayerRefreshLoadingState('network-layer', false, false);
      setHasNetworkLoadedOnce(true);
    } catch (error: unknown) {
      setLayerRefreshLoadingState(
        'network-layer',
        false,
        true,
        error instanceof Error
          ? error.message
          : 'Network layer failed to load',
      );
    }
  };

  const createNetworkLayer = (
    store: boolean = true,
  ): ArcGisLayerLike => {
    const renderer = {
      type: 'simple',
      symbol: {
        ...getStyle('line', 'network-layer', 'Network', layersStyle),
      },
    };

    const geoJsonLayer = new GeoJSONLayer({
      id: 'network-layer',
      url: `${BASE_API_URL}/network/sections/geo`,
      popupEnabled: false,
      renderer: renderer,
      spatialReference: { wkid: 3857 },
      outFields: ['*'],
    });

    setLayerRefreshLoadingState('network-layer', true, false);

    if (store) {
      setLayerData((prevData: Record<string, ArcGisLayerLike>) => ({
        ...prevData,
        'network-layer': geoJsonLayer,
      }));
    }

    return geoJsonLayer;
  };

  const createDirectionLayer = (
    store: boolean = true,
    zoomIn: boolean = false,
  ) => {
    const renderer = {
      type: 'simple',
      symbol: {
        type: 'simple-line',
        color: [54, 63, 255],
        width: 1.5,
        marker: {
          style: 'arrow',
          placement: 'end',
          color: [54, 63, 255],
          size: 1,
        },
      },
    };

    const geoJsonLayer = new GeoJSONLayer({
      id: 'direction-layer',
      url: `${BASE_API_URL}/network/sections/geo`,
      popupEnabled: false,
      renderer: renderer,
      spatialReference: { wkid: 3857 },
      outFields: ['*'],
    });

    if (store) {
      setLayerData((prevState: Record<string, ArcGisLayerLike>) => ({
        ...prevState,
        'direction-layer': geoJsonLayer,
      }));
    }

    if (zoomIn) {
      geoJsonLayer.on('layerview-create', function () {
        view.goTo(geoJsonLayer.fullExtent);
      });
    }

    return geoJsonLayer;
  };

  useEffect(() => {
    let hasRefreshData = esriConfig.request.interceptors?.find(
      (interceptedRequest: { headers?: Record<string, unknown> }) =>
        interceptedRequest?.headers?.hasOwnProperty('RefreshData'),
    );
    if (hasRefreshData) {
      esriConfig.request.interceptors.shift();
    }
  }, [layerData]);

  useEffect(() => {
    (async () => {
      const db = await getDB();

      const allLayers = await db.getAllKeys('layersStyle');
      const layers: DashboardSymbologyModelRecord = {};
      for (const key of allLayers) {
        const stringKey = typeof key === 'string' ? key : String(key);
        layers[stringKey] = await db.get('layersStyle', key as string);
      }
      setLayersStyle(layers);

      const allRules = await db.getAllKeys('layerRulesStyle');
      const rules: Record<string, { layerRules: LayerRuleStypeElement[]; url: string; expression: string }> = {};
      for (const key of allRules) {
        const stringKey = typeof key === 'string' ? key : String(key);
        rules[stringKey] = await db.get('layerRulesStyle', key as string);
      }
      setLayerRulesStyles(rules);
    })();

    return () => {
      if (clickEvent !== null) {
        clickEvent.remove();
        clickEvent = null;
      }
      clearHighlight();
    };
  }, []);

  useEffect(() => {
    const sync = resolveAssetLayerSearchSync(checkedNodesState, selectedNode);
    setSearchContent((prev) => ({
      ...prev,
      ...sync.searchContent,
    }));

    if (sync.updateSelectedNode) {
      setSelectedNode(toLayerListNode(sync.selectedNode));
    }
  }, [selectedNode, checkedNodesState]);

  function zoomToBreakCluster(view: ArcGisViewLike, clusterGraphic: ArcGisGraphicLike) {
    const zoomInLevel = view.zoom + 1;

    Promise.resolve(view.goTo({ target: clusterGraphic.geometry, zoom: zoomInLevel }))
      .then(() => {
        setTimeout(() => {
          view
            .hitTest({ x: view.width / 2, y: view.height / 2 })
            .then((response: { results: ArcGisGraphicLike[] }) => {
              const cluster = response.results.find(
                (r: ArcGisGraphicLike) =>
                  r.graphic?.attributes && r.graphic.attributes.cluster_count,
              );
              if (cluster?.graphic?.attributes) {
                const clusterCount = Number(cluster.graphic.attributes.cluster_count ?? 0);
                if (
                  clusterCount > 1 &&
                  view.zoom < (view.constraints.maxZoom ?? Number.POSITIVE_INFINITY)
                ) {
                  zoomToBreakCluster(view, clusterGraphic);
                }
              }
            });
        }, 300);
      });
  }

  useEffect(() => {
    if (!view || !baseLayer) return;

    if (showDirection) {
      if (!layerData['direction-layer']) {
        const directionLayer = createDirectionLayer(true);
        view.map.add(directionLayer);
        setLayerData((prevState: Record<string, ArcGisLayerLike>) => ({
          ...prevState,
          'direction-layer': directionLayer,
        }));
      }

      const directionLayer = layerData['direction-layer'];
      if (directionLayer) {
        directionLayer.order = view.map.layers.length - 1;
      }
    } else {
      if (layerData['direction-layer']) {
        view.map.remove(layerData['direction-layer']);
        setLayerData((prevState: Record<string, ArcGisLayerLike>) => {
          const updated = { ...prevState };
          delete updated['direction-layer'];
          return updated;
        });
      }
    }
  }, [showDirection, baseLayer]);

  let startGraphic: Graphic | null = null;
  let stopGraphic: Graphic | null = null;
  let startLabelGraphic: Graphic | null = null;

  useEffect(() => {
    if (!view || baseLayer === null) {
      networkAttachedViewRef.current = null;
      return;
    }

    const map = view.map;
    if (!map) {
      return;
    }

    const viewChanged = networkAttachedViewRef.current !== view;
    let networkLayer =
      typeof map.findLayerById === 'function'
        ? (map.findLayerById('network-layer') as ArcGisLayerLike | null)
        : null;

    if (!networkLayer || viewChanged) {
      const staleNetwork = map.findLayerById?.('network-layer');
      if (staleNetwork) {
        map.remove(staleNetwork);
      }
      networkLayer = createNetworkLayer(true);
      const insertIndex = map.layers.length > 0 ? 1 : 0;
      map.add(networkLayer, insertIndex);
      networkAttachedViewRef.current = view;
      // First attach / view change: frame the network so geometry is visible.
      // Legend toggles use settleNetworkLayerOverlay(..., false) and do not zoom.
      void settleNetworkLayerOverlay(view, networkLayer, true);
    } else {
      networkLayer.visible = true;
      networkAttachedViewRef.current = view;
    }

    if (clickEvent !== null) {
        clickEvent.remove();
        clickEvent = null;
      }

      clickEvent = view.on('click', function (event: UnknownRecord) {
        view.hitTest(event).then(async function (response: { results: ArcGisGraphicLike[] }) {
          if (response.results.length) {
            const clickedGraphic = response.results.find(
              (result: ArcGisGraphicLike) => result.graphic?.layer !== baseLayer,
            )?.graphic;

            if (!clickedGraphic) return;

            clearHighlight();

            const mapLayerId =
              typeof clickedGraphic.layer?.id === 'string'
                ? clickedGraphic.layer.id
                : null;
            const isSdmDefectLayer = isActiveDefectMapLayerId(
              mapLayerId,
              activeDefectLayerIdsRef.current,
            );

            if (
              clickedGraphic.symbol?.color === 'green' ||
              clickedGraphic.symbol?.color === 'red'
            ) {
              return;
            }

            if (clickedGraphic.geometry.type === 'polyline') {
              const paths = clickedGraphic.geometry.paths;

              if (paths && paths.length > 0 && paths[0][0]) {
                let polylineExtent = clickedGraphic.geometry.extent;
                if (polylineExtent && polylineExtent.spatialReference?.wkid !== 4326) {
                  polylineExtent =
                    projectGeometry(polylineExtent, { wkid: 4326 }) ??
                    polylineExtent;
                }
              }

              if (paths && paths.length > 0) {
                if (startGraphic) view.graphics.remove(startGraphic);
                if (stopGraphic) view.graphics.remove(stopGraphic);
                if (startLabelGraphic) view.graphics.remove(startLabelGraphic);

                // Don't show start/end markers for survey coverage layers —
                // direction of travel is unknown for those routes.
                // SDM defect polylines are score segments, not route direction.
                const clickLayerId = String(clickedGraphic.layer?.id ?? '');
                const normalizedClickLayerId = clickLayerId.replace(/^favourites_/, '');
                const isCoverageLayer =
                  Boolean(clickLayerId) &&
                  (coverageLayerKeysRef.current.has(clickLayerId) ||
                    coverageLayerKeysRef.current.has(normalizedClickLayerId) ||
                    layerClickConfigRegistryRef.current[clickLayerId]
                      ?.clickHandler === 'survey-coverage' ||
                    layerClickConfigRegistryRef.current[normalizedClickLayerId]
                      ?.clickHandler === 'survey-coverage');
                const clickHandlerId = resolveClickHandlerId(
                  clickLayerId,
                  clickedGraphic.attributes,
                  layerClickConfigRegistryRef.current,
                );

                if (!isCoverageLayer && !isSdmDefectLayer && clickHandlerId !== 'survey-coverage') {
                  const startPointCoords = paths[0][0];
                  const stopPointCoords = paths[0][paths[0].length - 1];

                  const startTextSymbol = {
                    type: 'text',
                    text: 'Start',
                    color: 'green',
                    haloColor: 'white',
                    haloSize: '1px',
                    font: { size: 12, family: 'Roboto', weight: 'bold' },
                    xoffset: 0,
                    yoffset: -15,
                  };

                  startLabelGraphic = new Graphic({
                    geometry: {
                      type: 'point',
                      spatialReference: clickedGraphic.geometry.spatialReference,
                      x: startPointCoords[0],
                      y: startPointCoords[1],
                    },
                    symbol: startTextSymbol,
                  });

                  const startSymbol = {
                    type: 'simple-marker',
                    color: 'green',
                    size: '12px',
                    outline: { color: 'white', width: 1 },
                  };

                  const stopSymbol = {
                    type: 'simple-marker',
                    color: 'red',
                    size: '10px',
                    outline: { color: 'white', width: 1 },
                  };

                  startGraphic = new Graphic({
                    geometry: {
                      type: 'point',
                      spatialReference: clickedGraphic.geometry.spatialReference,
                      x: startPointCoords[0],
                      y: startPointCoords[1],
                    },
                    symbol: startSymbol,
                  });

                  stopGraphic = new Graphic({
                    geometry: {
                      type: 'point',
                      spatialReference: clickedGraphic.geometry.spatialReference,
                      x: stopPointCoords[0],
                      y: stopPointCoords[1],
                    },
                    symbol: stopSymbol,
                  });

                  view.graphics.addMany([
                    startGraphic,
                    startLabelGraphic,
                    stopGraphic,
                  ]);
                }

              }
            } else {
            }

            if (clickedGraphic.attributes && clickedGraphic.geometry) {
              const clusterCount = Number(clickedGraphic.attributes.cluster_count ?? 0);
              if (clusterCount > 1) {
                zoomToBreakCluster(view, clickedGraphic);
                return;
              }

              let lat = 0,
                long = 0;
              if (clickedGraphic.geometry) {
                let point;
                if (
                  clickedGraphic.geometry.spatialReference?.latestWkid !== 4326
                ) {
                  const outSpatialReference = { wkid: 4326 };
                  const geo = projectGeometry(
                    clickedGraphic.geometry,
                    outSpatialReference,
                  ) as Geometry | null;
                  if (geo) {
                    if (clickedGraphic.geometry.type === 'polyline') {
                      point = geo.paths?.[0]?.[0] || [0, 0];
                      lat = point[1];
                      long = point[0];
                    } else {
                      point = geo.getPoint ? geo.getPoint(0, 0) : geo;
                      lat = point.latitude || point.y || 0;
                      long = point.longitude || point.x || 0;
                    }
                  }
                } else {
                  if (clickedGraphic.geometry.type === 'polyline') {
                    point = clickedGraphic.geometry.paths?.[0]?.[0] || [0, 0];
                    lat = point[1];
                    long = point[0];
                  } else {
                    point = clickedGraphic.geometry.getPoint
                      ? clickedGraphic.geometry.getPoint(0, 0)
                      : clickedGraphic.geometry;
                    lat = point.latitude || point.y || 0;
                    long = point.longitude || point.x || 0;
                  }
                }
              }

              if (isSdmDefectLayer) {
                const graphicAttributes =
                  clickedGraphic.attributes &&
                  typeof clickedGraphic.attributes === 'object'
                    ? (clickedGraphic.attributes as Record<string, unknown>)
                    : {};
                const layerTitle =
                  typeof clickedGraphic.layer?.title === 'string'
                    ? clickedGraphic.layer.title
                    : undefined;
                const normalizedMapLayerId = normalizeActiveDefectMapLayerId(
                  mapLayerId
                    ? stripSdmOverviewMapLayerSuffix(mapLayerId)
                    : null,
                );
                const activeLayer = activeDefectLayersRef.current.find(
                  (layer) =>
                    toActiveDefectMapLayerId(layer.id) === normalizedMapLayerId,
                );
                const sourceActiveLayerId: ActiveDefectLayerId | null =
                  activeLayer?.id ??
                  (normalizedMapLayerId
                    ? (fromActiveDefectMapLayerId(
                        normalizedMapLayerId,
                      ) as ActiveDefectLayerId)
                    : null);
                const overlayPresentation: SdmFeatureInfoPresentation | undefined =
                  activeLayer != null &&
                  isDefectOverlayLayerKind(activeLayer.layerKind)
                    ? activeLayer.layerKind
                    : isCrackmapWfsFeature(graphicAttributes)
                      ? 'crackmap'
                      : undefined;

                setAttributesSourceActiveLayerId(sourceActiveLayerId);
                setAttributesModalData(
                  buildSdmFeatureInfoDetails(graphicAttributes, {
                    ...(layerTitle !== undefined ? { layerTitle } : {}),
                    ...(overlayPresentation != null
                      ? { presentation: overlayPresentation }
                      : { latitude: lat, longitude: long }),
                  }),
                );
                showModal('Attributes');
              } else {
                const clickLayerId = String(clickedGraphic.layer?.id ?? mapLayerId ?? '');
                const normalizedClickLayerId = clickLayerId.replace(
                  /^favourites_/,
                  '',
                );
                const isCoverageLayer =
                  Boolean(clickLayerId) &&
                  (coverageLayerKeysRef.current.has(clickLayerId) ||
                    coverageLayerKeysRef.current.has(normalizedClickLayerId) ||
                    layerClickConfigRegistryRef.current[clickLayerId]
                      ?.clickHandler === 'survey-coverage' ||
                    layerClickConfigRegistryRef.current[normalizedClickLayerId]
                      ?.clickHandler === 'survey-coverage');
                const isSurveyImageViewerLayer = Object.values(
                  geoserverLayerRefs.current,
                ).includes(clickedGraphic.layer);
                const clickHandlerId = resolveClickHandlerId(
                  clickLayerId,
                  clickedGraphic.attributes,
                  layerClickConfigRegistryRef.current,
                );

                if (
                  clickedGraphic.attributes?.survey_type &&
                  !clickedGraphic.attributes?.file_path
                ) {
                  // Survey section clicked — open the Survey Layer Panel instead
                  addSurveyToPanel({
                    ...clickedGraphic.attributes,
                    latitude: lat,
                    longitude: long,
                  });
                  setSurveyLayerPanelOpen(true);
                  setHighlightedPanelSurveySlug(
                    clickedGraphic.attributes?.survey_slug
                      ? String(clickedGraphic.attributes.survey_slug)
                      : null,
                  );
                } else if (
                  clickedGraphic.attributes?.file_path &&
                  clickedGraphic.attributes?.image_type
                ) {
                  // WFS survey data point clicked — open Image Viewer
                  // Skip Dashboard highlight; ImageViewerContext manages its own highlight
                  handleWfsSurveyPointClick(clickedGraphic);
                } else if (
                  isSurveyImageViewerLayer ||
                  isCoverageLayer ||
                  clickHandlerId === 'survey-coverage' ||
                  clickHandlerId === 'survey-image-point' ||
                  !updatesAttributesModal(clickHandlerId)
                ) {
                } else {
                  setAttributesSourceActiveLayerId(null);
                  setAttributesModalData({
                    ...clickedGraphic.attributes,
                    latitude: lat,
                    longitude: long,
                    geometry: clickedGraphic.geometry,
                    layerData,
                  });
                  showModal('Attributes');
                }
              }

              // Only apply Dashboard highlight for non-image-viewer clicks
              const isImageViewerClick =
                !isSdmDefectLayer &&
                Boolean(
                  clickedGraphic.attributes?.file_path &&
                    clickedGraphic.attributes?.image_type,
                );
              if (!isImageViewerClick) {
                const layerView = await view
                  .whenLayerView(clickedGraphic.layer)
                  .catch(() => null);
                if (layerView) {
                  clearHighlight();
                  highlight = layerView.highlight(clickedGraphic);
                }
              } else {
                // Clear any existing Dashboard highlight so it doesn't linger
                clearHighlight();
              }
            }
          }

          if (layerData['direction-layer']) {
            const directionLayer = layerData['direction-layer'];
            directionLayer.order = view.map.layers.length - 1;
          }
        });
      });
  }, [baseLayer, view]);

  const onLayerChange = async (title: string) => {
    let layerUrl = `https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png?api_key=${process.env.REACT_APP_STADIA_MAPS_API_KEY}`;
    let layer: ArcGisLayerLike;

    if (title === 'OS MasterMap Grey Scale') {
      layerUrl =
        'https://api.emapsite.com/dataservicenoauth/api/wmts/xais_2/1.0.0/wMasterMap:gmastermap_schema9/default/EPSG:3857/EPSG:3857:{z}/{y}/{x}.png';
      layer = new WebTileLayer({
        name: title,
        title: title,
        urlTemplate: layerUrl,
        visible: true,
      });
    } else if (title === 'OS Zoomstack') {
      layerUrl =
        'https://api.emapsite.com/dataservicenoauth/api/wmts/xais/1.0.0/wMasterMap:gmastermap_schema9/default/EPSG:3857/EPSG:3857:{z}/{y}/{x}.png';
      layer = new WebTileLayer({
        name: title,
        title: title,
        urlTemplate: layerUrl,
        visible: true,
      });
    } else if (title === 'Alidade Smooth') {
      layerUrl = `https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png?api_key=${process.env.REACT_APP_STADIA_MAPS_API_KEY}`;
      layer = new WebTileLayer({
        name: title,
        title: title,
        urlTemplate: layerUrl,
        visible: true,
      });
    } else if (title === 'Alidade Smooth Dark') {
      layerUrl = `https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?api_key=${process.env.REACT_APP_STADIA_MAPS_API_KEY}`;
      layer = new WebTileLayer({
        name: title,
        title: title,
        urlTemplate: layerUrl,
        visible: true,
      });
    } else if (title === 'OSM Bright') {
      layerUrl = `https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png?api_key=${process.env.REACT_APP_STADIA_MAPS_API_KEY}`;
      layer = new WebTileLayer({
        name: title,
        title: title,
        urlTemplate: layerUrl,
        visible: true,
      });
    } else if (title === 'Google Satellite') {
      layerUrl = `https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
      layer = new WebTileLayer({
        name: title,
        title: title,
        urlTemplate: layerUrl,
        visible: true,
      });
    } else if (title === 'StadiaMaps') {
      layerUrl = `https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png?api_key=${process.env.REACT_APP_STADIA_MAPS_API_KEY}`;
      layer = new WebTileLayer({
        name: title,
        title: title,
        urlTemplate: layerUrl,
        visible: true,
      });
    } else {
      layer = new WebTileLayer({
        name: title,
        title: title,
        urlTemplate: layerUrl,
        visible: true,
      });
    }

    if (view.map.layers.length > 0) {
      view.map.layers.removeAt(0);
    }

    view.map.layers.add(layer, 0);

    setBaseLayer(layer);
    setCurrentLayer(title);
  };

  useEffect(() => {
    if (!view) return;

    view.when(() => {
      view.constraints = {
        minZoom: 2,
        maxZoom: 30,
        snapToZoom: false,
      };

      // add virtual LODs for higher zoom
      const baselayer = view.map?.layers?.getItemAt(0) as ArcGisLayerLike | undefined;
      const baseLods = baselayer?.tileInfo?.lods || view.constraints.lods || [];
      if (baseLods && baseLods.length) {
        const last = baseLods[baseLods.length - 1];
        const extra: UnknownRecord[] = [];
        for (let i = 1; i <= 10; i++) {
          extra.push({
            level: (last.level ?? baseLods.length - 1) + i,
            resolution: last.resolution / Math.pow(2, i),
            scale: last.scale / Math.pow(2, i),
          });
        }
        view.constraints.lods = [...baseLods, ...extra];
      }
    });

    return () => { };
  }, [view]);

  function extractFilename(raw: string) {
    if (!raw) return '';
    try {
      const u = new URL(raw);
      const parts = u.pathname.split('/');
      return parts[parts.length - 1].split('?')[0] || '';
    } catch {
      const parts = String(raw).split('/');
      return parts[parts.length - 1].split('?')[0] || '';
    }
  }

  useEffect(() => {
    if (!view) return;

    const updateLayersBasedOnZoom = () => {
      const zoomLevel = view.zoom;
      if (zoomLevel >= 18) {
        setZoomStackIsAllowed(true);
        if (zoomLevel === MAX_ZOOM) {
          setIsClusteringEnabled(false);
        } else if (zoomLevel < MAX_ZOOM) {
          if (user?.clustering === true) {
            setIsClusteringEnabled(true);
          }
        }
      } else if (zoomLevel < 18 && zoomLevel > -1) {
        setZoomStackIsAllowed(false);

        const layersToCheck = [
          'StadiaMaps',
          'Alidade Smooth',
          'Alidade Smooth Dark',
          'OSM Bright',
          'Google Satellite',
        ];

        let currentLayer = view.map.layers.items[0]?.name;

        if (!currentLayer || !layersToCheck.includes(currentLayer)) {
          for (const layerName of layersToCheck) {
            if (
              !view.map.layers.some(
                (layer: { name: string }) => layer.name === layerName,
              )
            ) {
              currentLayer = layerName;
              break;
            }
          }
        }

        const hasBasemap = view.map.layers.some((layer: { name?: string }) =>
          layersToCheck.includes(String(layer.name ?? '')),
        );
        if (view.map.layers.length === 0 || !hasBasemap) {
          onLayerChange(currentLayer);
        }
      }
    };

    const zoomWatcher = reactiveUtils.watch(
      () => view.zoom,
      updateLayersBasedOnZoom,
    );
    return () => {
      zoomWatcher.remove();
    };
  }, [view, user?.clustering]);

  useEffect(() => {
    if (!view) return;

    const rebuildTravelDirectionSymbol = (
      layerKey: string,
      symbol: MutableUnknownRecord | undefined,
      zoom: number,
    ): MutableUnknownRecord | undefined => {
      if (!symbol || symbol.type !== 'cim') {
        return symbol;
      }
      const legendStyle = layersStyle[layerKey];
      return buildSurveyTravelDirectionSymbol(
        {
          ...symbol,
          color:
            legendStyle?.currentColor ??
            symbol.color ??
            symbol.currentColor,
          currentColor:
            legendStyle?.currentColor ??
            symbol.currentColor ??
            symbol.color,
          width:
            legendStyle?.currentWidth !== undefined
              ? `${legendStyle.currentWidth}px`
              : (symbol.width ?? symbol.currentWidth),
          currentWidth:
            legendStyle?.currentWidth ??
            symbol.currentWidth ??
            symbol.width,
        },
        zoom,
      );
    };

    const updateRendererTravelDirectionArrows = (
      layer: ArcGisLayerLike | undefined,
      layerKey: string,
      zoom: number,
    ): void => {
      if (!layer?.renderer) {
        return;
      }
      const renderer = layer.renderer;
      let didUpdate = false;
      if (renderer.type === 'unique-value') {
        if (renderer.defaultSymbol?.type === 'cim') {
          renderer.defaultSymbol = rebuildTravelDirectionSymbol(
            layerKey,
            renderer.defaultSymbol,
            zoom,
          );
          didUpdate = true;
        }
        if (Array.isArray(renderer.uniqueValueInfos)) {
          for (const info of renderer.uniqueValueInfos) {
            if (info.symbol?.type === 'cim') {
              info.symbol = rebuildTravelDirectionSymbol(
                layerKey,
                info.symbol,
                zoom,
              );
              didUpdate = true;
            }
          }
        }
      } else if (renderer.symbol?.type === 'cim') {
        renderer.symbol = rebuildTravelDirectionSymbol(
          layerKey,
          renderer.symbol,
          zoom,
        );
        didUpdate = true;
      }
      if (didUpdate) {
        layer.renderer = renderer;
      }
    };

    const syncTravelDirectionArrowsForZoom = (zoom: number): void => {
      const showArrows = shouldShowSurveyTravelDirectionArrows(zoom);
      if (prevShowTravelDirectionArrowsRef.current === showArrows) {
        return;
      }
      // Initialize without rewriting - layers are already built for the current zoom.
      if (prevShowTravelDirectionArrowsRef.current === null) {
        prevShowTravelDirectionArrowsRef.current = showArrows;
        return;
      }
      prevShowTravelDirectionArrowsRef.current = showArrows;

      for (const key of coverageLayerKeysRef.current) {
        const layer =
          layerData[key] ??
          (typeof view.map.findLayerById === 'function'
            ? view.map.findLayerById(key)
            : undefined);
        updateRendererTravelDirectionArrows(layer, key, zoom);
      }

      for (const [key, layer] of Object.entries(geoserverLayerRefs.current)) {
        if (layer.geometryType !== 'polyline') {
          continue;
        }
        const renderer = layer.renderer;
        const uniqueValueInfos = renderer?.uniqueValueInfos;
        const hasCimTravelDirection =
          renderer?.symbol?.type === 'cim' ||
          renderer?.defaultSymbol?.type === 'cim' ||
          (Array.isArray(uniqueValueInfos) &&
            uniqueValueInfos.some((info) => info.symbol?.type === 'cim'));
        if (!hasCimTravelDirection) {
          continue;
        }
        updateRendererTravelDirectionArrows(layer, key, zoom);
      }
    };

    const syncSurveyWfsPointSizesForZoom = (zoom: number): void => {
      const roundedZoom = roundSurveyWfsPointZoom(zoom);
      if (prevSurveyWfsPointZoomRef.current === roundedZoom) {
        return;
      }
      prevSurveyWfsPointZoomRef.current = roundedZoom;

      for (const [key, layer] of Object.entries(geoserverLayerRefs.current)) {
        if (layer.geometryType !== 'point' && layer.geometryType !== 'multipoint') {
          continue;
        }
        const renderer = layer.renderer?.clone
          ? (layer.renderer.clone() as ArcGisRendererLike)
          : layer.renderer;
        if (!renderer) continue;

        const baseSize =
          layersStyle[key]?.currentSize ?? SURVEY_WFS_POINT_DEFAULT_BASE_PX;
        const nextSize = `${resolveSurveyWfsPointSizePx(roundedZoom, baseSize)}px`;
        let didUpdate = false;

        const applyMarkerSize = (
          symbol: { type?: unknown; size?: unknown } | undefined,
        ): void => {
          if (!symbol || symbol.type !== 'simple-marker') {
            return;
          }
          if (String(symbol.size) === nextSize) {
            return;
          }
          symbol.size = nextSize;
          didUpdate = true;
        };

        applyMarkerSize(
          renderer.type === 'unique-value' ? renderer.defaultSymbol : renderer.symbol,
        );
        if (Array.isArray(renderer.uniqueValueInfos)) {
          for (const info of renderer.uniqueValueInfos) {
            applyMarkerSize(info.symbol);
          }
        }

        if (didUpdate) {
          layer.renderer = renderer;
        }
      }
    };

    syncTravelDirectionArrowsForZoom(view.zoom ?? 0);
    syncSurveyWfsPointSizesForZoom(view.zoom ?? 0);
    const travelDirectionZoomWatcher = reactiveUtils.watch(
      () => view.zoom as number,
      (zoom: number) => {
        syncTravelDirectionArrowsForZoom(zoom);
        syncSurveyWfsPointSizesForZoom(zoom);
      },
    );
    return () => {
      travelDirectionZoomWatcher.remove();
    };
  }, [view, layerData, layersStyle]);

  useEffect(() => {
    if (!view) return;
    const isDashboardVisible = isDashboardPath(location.pathname);
    if (isDashboardVisible && Object.keys(layerData).length > 0) {
      view.map.layers.forEach((layer: ArcGisLayerLike) => {
        if (layer.id && layer.visible === true) {
          layer.visible = true;
        }
      });
    }
  }, [location.pathname, view, layerData]);

  useEffect(() => {
    Object.values(layerData).forEach((layer: ArcGisLayerLike) => {
      if (layer.geometryType === 'point') {
        layer.featureReduction = isClusteringEnabled ? clusterConfig : null;
      }
    });
  }, [isClusteringEnabled, layerData]);

  const getLayerColor = (category: string) => {
    switch (category) {
      case 'Assets':
        return blue;
      case 'Forward Works Programme':
        return orange;
      case 'Treatment Lengths':
        return purple;
      case 'Hotspots':
        return yellow;
      case 'Accidents':
        return purple;
      case 'Network':
        return black;
    }
    return red;
  };

  function getDB() {
    if (!dbPromise) {
      dbPromise = openDB<LegendDBSchema>('LegendDB', 1, {
        upgrade(db) {
          db.createObjectStore('layersStyle');
          db.createObjectStore('layerRulesStyle');
        },
      });
    }
    return dbPromise;
  }

  const updateStyle = async (key: string, style: DashboardSymbologyModel) => {
    setLayersStyle((prev: DashboardSymbologyModelRecord) => {
      const updated = { ...prev, [key]: style };
      getDB()
        .then((db) => db.put('layersStyle', style, key))
        .catch((err) => console.warn('IDB write layersStyle failed', err));
      return updated;
    });
  };

  const updateLayerRulesStyle = async (
    key: string,
    url: string,
    valueExpression: string,
    layerRules: LayerRuleStypeElement[],
  ) => {
    const payload = { layerRules, url, expression: valueExpression };

    setLayerRulesStyles((prev: LayerRuleStyleRecord) => {
      const updated = { ...prev, [key]: payload };
      getDB()
        .then((db) => db.put('layerRulesStyle', payload, key))
        .catch((err) => console.warn('IDB write layerRulesStyle failed', err));
      return updated;
    });
  };

  const getStyle = (
    geometryType: 'line' | 'point',
    key: string,
    category: string | undefined,
    from: DashboardSymbologyModelRecord,
  ) => {
    if (from[key]) {
      if (from[key].style === 'cross' || from[key].style === 'x') {
        return {
          ...from[key],
          outline: {
            width: 6,
            color: from[key].currentColor,
          },
        };
      }
      return from[key];
    } else if (geometryType === 'point') {
      const style = {
        color: getLayerColor(category || ''),
        size: '22px',
        style: 'circle',
        currentStyle: 'symbols-sls-circle',
        type: 'simple-marker',
        angle: 0,
        currentWidth: 4,
        currentSize: 22,
        currentLineStyle: 'solid',
        currentMarkerStyle: 'circle',
        currentColor: getLayerColor(category || ''),
        currentAngle: 0,
      };

      updateStyle(key, style);
      return style;
    } else {
      const style = {
        color: getLayerColor(category || ''),
        width: '4px',
        cap: 'square',
        join: 'bevel',
        style: 'solid',
        currentStyle: 'symbols-sls-solid',
        type: 'simple-line',
        currentWidth: 4,
        currentSize: 22,
        currentLineStyle: 'solid',
        currentMarkerStyle: 'circle',
        currentColor: getLayerColor(category || ''),
        currentAngle: 0,
      };
      updateStyle(key, style);
      return style;
    }
  };

  useEffect(() => {
    Object.values(layerData).forEach((layer: ArcGisLayerLike) => {
      if (layer.geometryType === 'point') {
        layer.featureReduction = user?.clustering ? clusterConfig : null;
        if (layer.featureReduction) {
          layer.featureReduction.symbol = {
            type: 'simple-marker',
            color: layersStyle[String(layer.id)]?.currentColor,
          };
        }
      }
    });
  }, [user, layerData]);

  useEffect(() => {
    Object.keys(layerRulesStyles).forEach(async (key) => {
      if (!checkedNodesState.some((node) => node.key === key)) return;

      const { url, expression, layerRules } = layerRulesStyles[key];

      if (!view.map.findLayerById(key)) {
        const geoj = new GeoJSONLayer({
          id: key,
          url: url,
          popupEnabled: false,
          renderer: {
            type: 'unique-value',
            defaultSymbol: {
              type: 'simple-line',
              color: layersStyle[key]?.currentColor || 'black',
            },
            valueExpression: expression,
            uniqueValueInfos: layerRules.map((rule) => ({
              value:
                rule.dataType === 'Integer'
                  ? rule.label
                  : `${rule.name}-${rule.value}`,
              symbol: computeStyle(rule.style, 'simple-line'),
            })),
          },
          spatialReference: { wkid: 3857 },
          outFields: ['*'],
        });

        try {
          await geoj.when();
          view.map.layers.add(geoj);
          setLayerData((prevState: Record<string, ArcGisLayerLike>) => ({
            ...prevState,
            [key]: geoj,
          }));
        } catch (error) {
          return;
        }
      }
    });
  }, [layerRulesStyles, checkedNodesState]);

  useEffect(() => {
    Object.values(layerData).forEach((layer: ArcGisLayerLike) => {
      if (layer.geometryType === 'point') {
        if (layer.featureReduction) {
          layer.featureReduction.symbol = {
            type: 'simple-marker',
            color: layersStyle[String(layer.id)]?.currentColor,
          };
        }
      }
    });
  }, [layersStyle]);

  const handleContextMenuRefreshClicked = async (
    selectedKeys: Key[],
    contextNode?: ContextMenuLayerNode | null,
  ): Promise<void> => {
    const selection = resolveSelectedLayerKey(selectedKeys, contextNode);
    if (!selection) {
      return;
    }

    const { rawKey: rawSelectedNodeKey, layerKey: selectedNodeKey } = selection;
    const loadingKeys = getLoadingKeysForRefresh(
      rawSelectedNodeKey,
      selectedNodeKey,
    );

    const setLoadingStateForKeys = (
      isLoading: boolean,
      hasError = false,
      errorMessage = '',
    ) => {
      loadingKeys.forEach((key: string) =>
        setLayerRefreshLoadingState(key, isLoading, hasError, errorMessage),
      );
    };

    const newLayerData = { ...layerData };
    const newLayers: RefreshableGeoJsonLayer[] = [];
    let geoJsonLayer: RefreshableGeoJsonLayer | null = null;
    const isNetworkLayerSelected = selectedNodeKey === 'network-layer';
    const apiRootUrl = process.env.REACT_APP_API_URL ?? '';

    if (isNetworkLayerSelected) {
      setLoadingStateForKeys(true, false);
      let blobUrl: string | null = null;
      try {
        const geoJson = await fetchGeoJsonWithRefresh(
          buildNetworkGeoLayerUrl(BASE_API_URL),
        );
        blobUrl = createGeoJsonBlobUrl(geoJson);
        geoJsonLayer = new GeoJSONLayer({
          id: 'network-layer',
          url: blobUrl,
          popupEnabled: false,
          renderer: {
            type: 'simple',
            symbol: {
              ...getStyle('line', 'network-layer', 'Network', layersStyle),
            },
          },
          spatialReference: { wkid: 3857 },
          outFields: ['*'],
        }) as RefreshableGeoJsonLayer;

        await geoJsonLayer.load();
      } catch (error: unknown) {
        let errorMessage = 'Failed to load layer';
        if (error instanceof Error) {
          errorMessage = error.message;
        }
        setLoadingStateForKeys(false, true, errorMessage);
        return;
      } finally {
        if (blobUrl) {
          scheduleBlobUrlRevoke(blobUrl);
        }
      }
    } else {
      const normalizedContextNode = normalizeFavouritesContextNode(contextNode);
      const rawNode: ContextMenuLayerNode | null =
        normalizedContextNode ||
        checkedNodesState.find((n: LayerListNode) => n.key === selectedNodeKey) ||
        (selectedNode?.key === selectedNodeKey ? selectedNode : null);
      if (!rawNode) {
        setLoadingStateForKeys(false, true, 'Layer not found');
        return;
      }

      const existingMapLayer = view.map.findLayerById(selectedNodeKey) as
        | { url?: string }
        | undefined;
      const existingLayerUrl =
        (layerData[selectedNodeKey] as { url?: string } | undefined)?.url ??
        existingMapLayer?.url;
      const node = enrichContextMenuNode(rawNode, existingLayerUrl);

      const nodeKey = node.key ?? selectedNodeKey;
      const nodeCategory = node.category ?? '';
      const currentLayerRules = layerRulesStyles[nodeKey];
      setLoadingStateForKeys(true, false);

      const layerUrl = resolveContextMenuLayerUrl(
        node,
        currentLayerRules,
        apiRootUrl,
      );

      if (!layerUrl) {
        setLoadingStateForKeys(false, true, 'No layer endpoint found');
        return;
      }

      let blobUrl: string | null = null;
      const isSurveyCoverage = !shouldUseRefreshDataFetch(node);

      try {
        if (isSurveyCoverage) {
          const refreshUrl = resolveSurveyCoverageRefreshLayerUrl(layerUrl);
          geoJsonLayer = new GeoJSONLayer({
            id: nodeKey,
            url: refreshUrl,
            popupEnabled: false,
            spatialReference: { wkid: 3857 },
            outFields: ['*'],
          }) as RefreshableGeoJsonLayer;
          await geoJsonLayer.load();

          applySurveyCoverageLayerRenderer({
            layer: geoJsonLayer,
            nodeKey,
            nodeCategory,
            layerRules: currentLayerRules,
            layersStyle: layersStyle as Record<string, unknown>,
            getStyle: (geometryType, key, category, styles) => {
              const mapped =
                geometryType === 'polygon'
                  ? 'line'
                  : (geometryType as 'line' | 'point');
              return getStyle(
                mapped,
                key,
                category,
                styles as DashboardSymbologyModelRecord,
              );
            },
            computeStyle,
            clusterConfig,
            clusteringEnabled: Boolean(user?.clustering),
            mapZoom: view?.zoom ?? 0,
          });

          registerSurveyCoverageClickConfig(
            layerClickConfigRegistryRef.current,
            nodeKey,
            coverageLayerKeysRef.current,
          );
        } else {
          const geoJson = await fetchGeoJsonWithRefresh(layerUrl);
          blobUrl = createGeoJsonBlobUrl(geoJson);

          geoJsonLayer = new GeoJSONLayer({
            id: nodeKey,
            url: blobUrl,
            popupEnabled: false,
            spatialReference: { wkid: 3857 },
            outFields: ['*'],
          }) as RefreshableGeoJsonLayer;

          await geoJsonLayer.load();

          applyGeoJsonLayerRenderer({
            layer: geoJsonLayer,
            nodeKey,
            nodeCategory,
            layerRules: currentLayerRules,
            layersStyle: layersStyle as Record<string, unknown>,
            getStyle: (geometryType, key, category, styles) => {
              const mapped =
                geometryType === 'polygon'
                  ? 'line'
                  : (geometryType as 'line' | 'point');
              return getStyle(
                mapped,
                key,
                category,
                styles as DashboardSymbologyModelRecord,
              );
            },
            computeStyle,
            clusterConfig,
            clusteringEnabled: Boolean(user?.clustering),
          });
        }

        setLoadingStateForKeys(false, false);
      } catch (error: unknown) {
        const errorMessage = isSurveyCoverage
          ? formatSurveyRefreshError(error)
          : error instanceof Error
            ? error.message
            : 'Failed to load layer';
        console.error(
          isSurveyCoverage
            ? `Survey layer error: ${nodeKey}`
            : `Failed to load layer: ${nodeKey}`,
          error,
        );
        setLoadingStateForKeys(false, true, errorMessage);
        return;
      } finally {
        if (blobUrl) {
          scheduleBlobUrlRevoke(blobUrl);
        }
      }
    }

    if (!geoJsonLayer) {
      return;
    }

    newLayerData[selectedNodeKey] = geoJsonLayer as ArcGisLayerLike;
    newLayers.push(geoJsonLayer);

    const existingLayer = view.map.layers.find(
      (layer: ArcGisLayerLike) => layer.id === selectedNodeKey,
    );
    if (existingLayer) {
      view.map.layers.remove(existingLayer);
    }

    view.map.layers.addMany(newLayers);
    setLayerData(newLayerData);

    if (isNetworkLayerSelected && geoJsonLayer) {
      try {
        await waitForNetworkLayerPaintReady(
          view,
          geoJsonLayer as ArcGisLayerLike,
        );
        await waitForMapViewSettled(view);
        setHasNetworkLoadedOnce(true);
        setLoadingStateForKeys(false, false);
      } catch (error: unknown) {
        setLoadingStateForKeys(
          false,
          true,
          error instanceof Error ? error.message : 'Failed to load layer',
        );
      }
    }

    window.dispatchEvent(
      new CustomEvent('layer-refresh', {
        detail: { layerKey: selectedNodeKey, rawKey: rawSelectedNodeKey },
      }),
    );
  };

  const setLayerRefreshLoadingState = (
    layerId: string,
    isLoading: boolean,
    hasError = false,
    errorMessage = '',
  ) => {
    setLayerRefreshLoading((prevState: Record<string, { isLoading: boolean; hasError: boolean; errorMessage?: string }>) => ({
      ...prevState,
      [layerId]: { isLoading, hasError, errorMessage },
    }));
  };

  const onNodeChecked = (
    checkedNodes: LayerListNode[],
    currentSelectedNode?: LayerListNode,
  ) => {
    setCheckedNodesState((prevCheckedNodes: LayerListNode[]) =>
      applyCheckedNodesStateUpdate(prevCheckedNodes, checkedNodes, layerData),
    );

    if (currentSelectedNode !== undefined) {
      setSelectedNode(currentSelectedNode);
    }

    if (!view?.map?.layers) {
      return;
    }

    const newLayerData = { ...layerData };
    const newLayers: ArcGisLayerLike[] = [];
    const removedLayers: ArcGisLayerLike[] = [];

    checkedNodes.forEach((node: LayerListNode) => {
      if (!node?.key) {
        return;
      }
      if (newLayerData[node.key] !== undefined) {
        removedLayers.push(newLayerData[node.key]);
        const layerId = node.key;

        if (node.title === 'Network') {
          setLayerRefreshLoadingState(layerId, false, false);
        } else {
          setLayerRefreshLoadingState(layerId, false, false);
        }

        delete newLayerData[node.key];
        return;
      }

      let geoJsonLayer: ArcGisLayerLike = {};

      if (node.title === 'Network') {
        geoJsonLayer = createNetworkLayer(false);
      } else {
        const currentLayerRules = layerRulesStyles[node.key];
        geoJsonLayer = new GeoJSONLayer({
          id: node.key,
          url:
            currentLayerRules?.url ||
            resolveGeoJsonEndPointUrl(node.endPoint),
          popupEnabled: false,
          spatialReference: { wkid: 3857 },
          outFields: ['*'],
        });

        const layerId = node.key;
        setLayerRefreshLoadingState(layerId, true, false);

        (geoJsonLayer.when?.(() => {
            setLayerRefreshLoadingState(layerId, false);
            const uniqueRendered = currentLayerRules?.layerRules;
            if (geoJsonLayer.geometryType === 'point') {
              if (uniqueRendered) {
                const renderer = {
                  type: 'unique-value',
                  defaultSymbol: {
                    ...getStyle('point', node.key, node.category, layersStyle),
                  },
                  valueExpression: currentLayerRules?.expression,
                  uniqueValueInfos: uniqueRendered.map((us: LayerRuleStypeElement) => ({
                    value:
                      us.dataType === 'Integer'
                        ? us.label
                        : `${us.name}-${us.value}`,
                    symbol: { ...us.style },
                  })),
                };

                geoJsonLayer.renderer = renderer;
              } else {
                const renderer = {
                  type: 'simple',
                  symbol: {
                    ...getStyle('point', node.key, node.category, layersStyle),
                  },
                };
                geoJsonLayer.renderer = renderer;
              }
              geoJsonLayer.featureReduction =
                user?.clustering === true ? clusterConfig : null;
              if (geoJsonLayer.featureReduction) {
                geoJsonLayer.featureReduction.symbol = {
                  type: 'simple-marker',
                  color:
                    layersStyle?.[node.key]?.currentColor ??
                    geoJsonLayer.renderer?.symbol?.color ??
                    geoJsonLayer.renderer?.defaultSymbol?.color ??
                    'red',
                };
              }
            } else {
              if (uniqueRendered) {
                const renderer = {
                  type: 'unique-value',
                  defaultSymbol: {
                    ...getStyle('line', node.key, node.category, layersStyle),
                  },
                  valueExpression: currentLayerRules?.expression,
                  uniqueValueInfos: uniqueRendered.map((us: LayerRuleStypeElement) => ({
                    value:
                      us.dataType === 'Integer'
                        ? us.label
                        : `${us.name}-${us.value}`,
                    symbol: { ...us.style },
                  })),
                };
                geoJsonLayer.renderer = renderer;
              } else {
                const renderer = {
                  type: 'simple',
                  symbol: {
                    // type: "simple-line",  // autocasts as new SimpleLineSymbol()
                    ...getStyle('line', node.key, node.category, layersStyle),
                  },
                };
                geoJsonLayer.renderer = renderer;
              }
            }
            setLayerRefreshLoadingState(layerId, false, false);
          }) ?? Promise.resolve())
          .catch(() => {
            setLayerRefreshLoadingState(
              layerId,
              false,
              true,
              'Layer failed to load',
            );
          });
      }
      newLayerData[node.key] = geoJsonLayer;
      newLayers.push(geoJsonLayer);
    });
    if (removedLayers.length > 0) {
      stopMapViewAnimation(view);
    }
    view.map.layers.addMany(newLayers);
    view.map.layers.removeMany(removedLayers);
    setLayerData(newLayerData);

    const addedNetworkLayer = newLayers.find(
      (layer) => layer.id === 'network-layer',
    );
    if (addedNetworkLayer) {
      // User turned Network on from the legend — do not steal the current view.
      void settleNetworkLayerOverlay(view, addedNetworkLayer, false);
    }
  };

  const onNodeCheckedSurveyManager = (
    checkedNodes: LayerListNode[],
    currentSelectedNode?: LayerListNode,
  ) => {
    setCheckedNodesState((prevCheckedNodes: LayerListNode[]) =>
      applyCheckedNodesStateUpdate(prevCheckedNodes, checkedNodes, layerData),
    );

    if (currentSelectedNode) {
      setSelectedNode({
        ...currentSelectedNode,
        key: String(currentSelectedNode.key ?? '').replace(/^favourites_/, ''),
      });
    }

    const newLayerData = { ...layerData };
    const newLayers: ArcGisLayerLike[] = [];
    const removedLayers: ArcGisLayerLike[] = [];

    checkedNodes.forEach((node: LayerListNode) => {
      if (!node?.key) {
        return;
      }
      if (newLayerData[node.key] !== undefined) {
        removedLayers.push(newLayerData[node.key]);
        const layerId = node.key;
        setLayerRefreshLoadingState(layerId, false, false);
        delete newLayerData[node.key];
        unregisterSurveyCoverageClickConfig(
          layerClickConfigRegistryRef.current,
          node.key,
          coverageLayerKeysRef.current,
        );

        // Close surveys in the Survey Layer Panel that belong to this coverage layer
        surveyLayerPanelSurveysRef.current
          .filter(
            (e) =>
              `${e.surveyType?.toLowerCase()}-${e.surveyYear}` === node.key,
          )
          .forEach((e) => removeSurveyFromPanel(e.surveySlug));

        return;
      }

      if (!view?.map?.layers) {
        return;
      }

      let geoJsonLayer: ArcGisLayerLike = {};
      const currentLayerRules = layerRulesStyles[node.key];

      geoJsonLayer = new GeoJSONLayer({
        id: node.key,
        url: resolveGeoJsonEndPointUrl(node.endPoint),
        popupEnabled: false,
        spatialReference: { wkid: 3857 },
        outFields: ['*'],
      });

      const layerId = node.key;

      setLayerRefreshLoadingState(layerId, true, false);

      (geoJsonLayer.when?.(() => {
          applySurveyCoverageLayerRenderer({
            layer: geoJsonLayer as RefreshableGeoJsonLayer,
            nodeKey: node.key,
            nodeCategory: node.category ?? '',
            layerRules: currentLayerRules,
            layersStyle: layersStyle as Record<string, unknown>,
            getStyle: (geometryType, key, category, styles) => {
              const mapped =
                geometryType === 'polygon'
                  ? 'line'
                  : (geometryType as 'line' | 'point');
              return getStyle(
                mapped,
                key,
                category,
                styles as DashboardSymbologyModelRecord,
              );
            },
            computeStyle,
            clusterConfig,
            clusteringEnabled: Boolean(user?.clustering),
            mapZoom: view?.zoom ?? 0,
          });
          registerSurveyCoverageClickConfig(
            layerClickConfigRegistryRef.current,
            node.key,
            coverageLayerKeysRef.current,
          );
          setLayerRefreshLoadingState(layerId, false, false);
        }) ?? Promise.resolve())
        .catch((error: unknown) => {
          console.error(`Survey layer error: ${layerId}`, error);
          setLayerRefreshLoadingState(
            layerId,
            false,
            true,
            formatSurveyRefreshError(error),
          );
        });
      newLayerData[node.key] = geoJsonLayer;
      registerSurveyCoverageClickConfig(
        layerClickConfigRegistryRef.current,
        node.key,
        coverageLayerKeysRef.current,
      );
      newLayers.push(geoJsonLayer);
    });

    if (view?.map?.layers) {
      if (removedLayers.length > 0) {
        stopMapViewAnimation(view);
      }
      view.map.layers.addMany(newLayers);
      view.map.layers.removeMany(removedLayers);
    }
    setLayerData(newLayerData);
  };

  const bringLayerToTop = (layerKey: string) => {
    if (!view?.map?.layers) {
      return;
    }
    const normalizedKey = String(layerKey ?? '').replace(/^favourites_/, '');
    if (
      geoserverLayerRefs.current[normalizedKey] ||
      geoserverLayerRefs.current[layerKey] ||
      surveyWmtsLayerKeysRef.current.has(normalizedKey)
    ) {
      bringGeoserverLayerToTop(normalizedKey);
      return;
    }
    const layer = resolveMapLayerForBringToTop(normalizedKey);
    if (!layer) {
      return;
    }
    const treatAsWmts =
      surveyWmtsLayerKeysRef.current.has(normalizedKey) ||
      isSurveyWmtsLayer(layer);
    bringSurveyLayerForward(view.map, layer, activeDefectLayerIdsRef.current, {
      forceWmts: treatAsWmts,
      layersAboveImagery: treatAsWmts
        ? listSurveyVectorLayersAboveImagery()
        : undefined,
    });
    forceMapLayerStackPaint(view, layer, { refreshTiles: treatAsWmts });
    if (!treatAsWmts) {
      pinSurveyWmtsBelowOverlays();
    }
  };

  const toggleNavBarX = () => {
    setPrimaryIsExpanded((prev) => !prev);
  };

  const exportToShapefile = async (
    targetLayerNode?: any,
    legendTreeData?: readonly any[],
  ) => {
    if (!targetLayerNode || typeof targetLayerNode !== 'object' || !targetLayerNode.key) {
      return;
    }

    const previousController = exportAbortControllerRef.current;
    if (previousController) {
      previousController.abort();
    }
    const abortController = new AbortController();
    exportAbortControllerRef.current = abortController;
    const { signal } = abortController;

    const node = {
      ...targetLayerNode,
      key: String(targetLayerNode.key ?? '').replace(/^favourites_/, ''),
    };

    setIsExporting(true);

    let activeLayerKey = '';

    const reportExportProgress = (
      layerKey: string,
      message: string,
      counts?: { readonly current?: number; readonly total?: number },
    ) => {
      activeLayerKey = layerKey;
      setExportProgress((prev) =>
        buildExportProgressUpdate(layerKey, message, prev, counts),
      );
    };

    try {
      const zip = new JSZip();

      throwIfExportCancelled(signal);

      const layerId = node.key;
      const layer = layerData[layerId];

      if (!layer || !(layer instanceof GeoJSONLayer)) {
        return;
      }

      if (!layer.createQuery || !layer.queryFeatures) {
        return;
      }

      reportExportProgress(layerId, `Querying ${node.title ?? layerId}...`);

      const query = layer.createQuery();
      query.outFields = ['*'];
      query.returnGeometry = true;
      const result = await layer.queryFeatures(query);
      if (!result?.features?.length) {
        setExportProgress({
          layerKey: layerId,
          percent: 100,
          message: 'Nothing to export',
          hasError: true,
        });
        return;
      }

      let featuresForExport: MapFeatureLike[] = result.features.map(
        (feature: { geometry: unknown; attributes?: Record<string, unknown> }) => ({
          geometry: feature.geometry,
          attributes: { ...(feature.attributes || {}) },
        }),
      );

      const layerUrl =
        typeof layer.url === 'string'
          ? layer.url
          : typeof node.endPoint === 'string'
            ? `${process.env.REACT_APP_API_URL}/${node.endPoint}`
            : undefined;

      featuresForExport = await enrichFeaturesForShapefileExport(
        featuresForExport,
        layerId,
        layerUrl,
        (msg) => reportExportProgress(layerId, msg),
        signal,
        {
          layerName:
            typeof node.category === 'string' ? node.category : undefined,
        },
      );

      throwIfExportCancelled(signal);

      const pointFeatures: Feature[] = [];
      const lineFeatures: Feature[] = [];
      const polygonFeatures: Feature[] = [];

      const exportFeatureTotal = featuresForExport.length;
      const isNetworkExport = isNetworkSectionsGeoLayer(layerId);

      featuresForExport.forEach((feature, featureIndex) => {
        throwIfExportCancelled(signal);
        if (
          isNetworkExport &&
          exportFeatureTotal > 0 &&
          (featureIndex === 0 ||
            featureIndex === exportFeatureTotal - 1 ||
            (featureIndex + 1) % 250 === 0)
        ) {
          reportExportProgress(
            layerId,
            `Preparing features (${featureIndex + 1}/${exportFeatureTotal})...`,
            { current: featureIndex + 1, total: exportFeatureTotal },
          );
        }

        const geom = feature.geometry as {
          type?: string;
          x?: number;
          y?: number;
          paths?: number[][][];
          rings?: number[][][];
          spatialReference?: { wkid?: number };
        };
        const properties = feature.attributes || {};

        switch (geom.type) {
          case 'point':
            pointFeatures.push({
              geometry: {
                type: 'Point',
                x: geom.x || 0,
                y: geom.y || 0,
                spatialReference: geom.spatialReference,
              },
              attributes: { ...properties, layerId },
            });
            break;

          case 'polyline':
            (geom.paths || []).forEach((path: number[][], index: number) => {
              lineFeatures.push({
                geometry: {
                  type: 'polyline',
                  paths: [path],
                  spatialReference: geom.spatialReference,
                },
                attributes: {
                  ...properties,
                  layerId,
                  segment: index + 1,
                },
              });
            });
            break;

          case 'polygon':
            polygonFeatures.push({
              geometry: {
                type: 'Polygon',
                rings: geom.rings || [],
                spatialReference: geom.spatialReference,
              },
              attributes: { ...properties, layerId },
            });
            break;

          default:
            return;
        }
      });

      const exportLayerTitle = buildLegendLayerExportName(node, legendTreeData);
      const layerFolder = zip.folder(exportLayerTitle);

      const addShapefileGroup = (
        features: Feature[],
        shapeType: 'Point' | 'LineString' | 'Polygon',
        suffix: 'points' | 'lines' | 'polygons',
      ) => {
        if (features.length === 0 || !layerFolder) {
          return;
        }

        const { shp, shx, dbf, prj } = writeShapefile(features, shapeType);
        const prefix = `${exportLayerTitle}_${suffix}`;
        layerFolder.file(`${prefix}.shp`, shp);
        layerFolder.file(`${prefix}.shx`, shx);
        layerFolder.file(`${prefix}.dbf`, dbf);
        layerFolder.file(`${prefix}.prj`, prj);
      };

      addShapefileGroup(pointFeatures, 'Point', 'points');
      addShapefileGroup(lineFeatures, 'LineString', 'lines');
      addShapefileGroup(polygonFeatures, 'Polygon', 'polygons');

      if (Object.keys(zip.files).length === 0) {
        setExportProgress({
          layerKey: layerId,
          percent: 100,
          message: 'Nothing to export',
          hasError: true,
        });
        return;
      }

      throwIfExportCancelled(signal);

      reportExportProgress(layerId, 'Creating download...');
      const zipBlob = await zip.generateAsync({ type: 'blob' }, (metadata) => {
        if (!activeLayerKey || signal.aborted) return;
        setExportProgress((prev) => {
          const updated = buildExportProgressUpdate(
            activeLayerKey,
            'Creating download...',
            prev,
          );
          return {
            ...updated,
            percent: 92 + Math.round(metadata.percent * 0.08),
          };
        });
      });
      throwIfExportCancelled(signal);
      saveAs(zipBlob, `${exportLayerTitle}_shapefiles.zip`);
      setExportProgress({
        layerKey: layerId,
        percent: 100,
        message: 'Completed',
      });
    } catch (error) {
      if (isExportAbortError(error, signal)) {
        if (activeLayerKey) {
          setExportProgress({
            layerKey: activeLayerKey,
            percent: 0,
            message: 'Export cancelled',
            cancelled: true,
          });
        }
        return;
      }
      console.error('Error exporting to Shapefile:', error);
      if (activeLayerKey) {
        setExportProgress({
          layerKey: activeLayerKey,
          percent: 100,
          message: 'Export failed',
          hasError: true,
        });
      }
    } finally {
      if (exportAbortControllerRef.current === abortController) {
        exportAbortControllerRef.current = null;
      }
      setIsExporting(false);
      window.setTimeout(() => setExportProgress(null), 1500);
    }
  };


  useEffect(() => {
    if (!view) return;

    const settleSurveyLayerPanelLoad = (
      layerKey: string,
      result: { readonly ok: true } | { readonly ok: false; readonly message: string },
    ) => {
      setSurveyLayerPanelSurveys((prev) =>
        prev.map((entry) => {
          const layers = entry.layers.map((layer) =>
            layer.key === layerKey
              ? {
                  ...layer,
                  loading: false,
                  error: result.ok ? undefined : result.message,
                }
              : layer,
          );
          const anyLayerStillLoading = layers.some((layer) => !!layer.loading);
          return {
            ...entry,
            layers,
            // Clear survey-level loading once every pending layer for this survey has settled.
            loading: entry.loading && anyLayerStillLoading,
          };
        }),
      );
    };

    const applyPendingBringToTop = (key: string, mapLayer: ArcGisLayerLike): void => {
      // Keep pending key until another layer is selected so we can re-assert
      // after renderer/load
      if (pendingBringToTopLayerKeyRef.current !== key) {
        return;
      }
      const treatAsWmts = surveyWmtsLayerKeysRef.current.has(key) || isSurveyWmtsLayer(mapLayer);
      bringSurveyLayerForward(view.map, mapLayer, activeDefectLayerIdsRef.current, {
        forceWmts: treatAsWmts,
        layersAboveImagery: treatAsWmts
          ? listSurveyVectorLayersAboveImagery()
          : undefined,
      });
      forceMapLayerStackPaint(view, mapLayer, { refreshTiles: treatAsWmts });
      if (!treatAsWmts) {
        pinSurveyWmtsBelowOverlays();
      }
    };

    const handleToggle = async (ev: Event) => {
      const detail = (ev as CustomEvent)?.detail;
      if (!detail || !detail.layer) return;
      const { endpoint = '', enabled, color: detailColor, layer } = detail as {
        endpoint?: string;
        enabled: boolean;
        color?: string;
        layer: { key: string; name?: string; type?: string };
      };
      const key = layer.key || layer.name || endpoint;

      if (enabled) {
        if (geoserverLayerRefs.current[key]) {
          const existingLayer = geoserverLayerRefs.current[key];
          applyPendingBringToTop(key, existingLayer);
          beginSurveyLayerMapRender(key, layer.name || key);
          void (async () => {
            try {
              await waitForSurveyLayerViewReady(view, existingLayer);
              settleSurveyLayerPanelLoad(key, { ok: true });
              applyPendingBringToTop(key, existingLayer);
            } catch {
              settleSurveyLayerPanelLoad(key, { ok: true });
            } finally {
              endSurveyLayerMapRender(key);
            }
          })();
          return; // already added
        }

        try {
          const urlLower = (endpoint || '').toLowerCase();

          // WFS attempt to load as GeoJSON 
          if (
            layer.type === 'WFS' ||
            urlLower.includes('service=wfs') ||
            urlLower.includes('request=getfeature')
          ) {
            const getFeatureUrl = endpoint;
            const wfsColor = detailColor ?? WFS_LAYER_PALETTE[wfsColorIndexRef.current % WFS_LAYER_PALETTE.length];
            const geojsonLayer = new GeoJSONLayer({ url: getFeatureUrl, title: layer.name || key, outFields: ['*'], popupEnabled: false } as UnknownRecord) as ArcGisLayerLike;
            view.map.add(geojsonLayer);
            geoserverLayerRefs.current[key] = geojsonLayer;
            applyPendingBringToTop(key, geojsonLayer);
            // Keep panel & map loading until the layer has painted.
            beginSurveyLayerMapRender(key, layer.name || key);
            void (async () => {
              try {
                await geojsonLayer.when?.();
                let renderer: MutableUnknownRecord;
                const geomType: string = geojsonLayer.geometryType || '';
                if (geomType === 'point' || geomType === 'multipoint') {
                  const baseSize =
                    layersStyle[key]?.currentSize ?? SURVEY_WFS_POINT_DEFAULT_BASE_PX;
                  const pointSizePx = resolveSurveyWfsPointSizePx(
                    view?.zoom ?? 0,
                    baseSize,
                  );
                  renderer = {
                    type: 'simple',
                    symbol: {
                      type: 'simple-marker',
                      color: wfsColor,
                      size: `${pointSizePx}px`,
                      outline: { color: 'white', width: 1 },
                    },
                  };
                } else if (geomType === 'polyline') {
                  renderer = {
                    type: 'simple',
                    symbol: buildSurveyTravelDirectionSymbol(
                      {
                        type: 'simple-line',
                        color: wfsColor,
                        width: '3px',
                        style: 'solid',
                      },
                      view?.zoom ?? 0,
                    ),
                  };
                } else {
                  // polygon or unknown
                  renderer = {
                    type: 'simple',
                    symbol: {
                      type: 'simple-fill',
                      color: wfsColor,
                      outline: { color: wfsColor, width: 1 },
                    },
                  };
                }
                geojsonLayer.renderer = renderer;
                // Re-assert after renderer 
                applyPendingBringToTop(key, geojsonLayer);

                try {
                  await waitForSurveyLayerViewReady(view, geojsonLayer);
                  settleSurveyLayerPanelLoad(key, { ok: true });
                  applyPendingBringToTop(key, geojsonLayer);
                } finally {
                  endSurveyLayerMapRender(key);
                }
                // Layer may have been unchecked while loading — don't start a goTo.
                if (geoserverLayerRefs.current[key] === geojsonLayer) {
                  flyToSurveyLayerIfOutOfView(view, geojsonLayer);
                }
                // Orientation can be slow on large WFS layers — do not block UI on it.
                if (geomType === 'polyline') {
                  void orientLayerFeaturesToCourseBearing(geojsonLayer);
                }
              } catch (err: unknown) {
                settleSurveyLayerPanelLoad(key, {
                  ok: false,
                  message: err instanceof Error ? err.message : 'Layer failed to load',
                });
                endSurveyLayerMapRender(key);
              }
            })();
            return;
          }

          // WMTS
          if (layer.type === 'WMTS' || urlLower.includes('service=wmts') || urlLower.includes('wmts')) {
            // TODO: Confirm parsing once WMTS layers are stored in DB; this assumes the endpoint format.
            const wmtsUrl = endpoint.substring(0, endpoint.lastIndexOf('/'));;
            const id = endpoint.substring(endpoint.lastIndexOf('/') + 1);
            const wmts = new WMTSLayer({
              url: wmtsUrl, title: layer.name || key, activeLayer: {
                
                id: id,
                tileMatrixSet: "EPSG:900913:20",
                style: 'raster',
                format: 'image/png',
              },
              serviceMode: 'KVP',
            } as UnknownRecord) as ArcGisLayerLike;
            view.map.add(wmts);
            geoserverLayerRefs.current[key] = wmts;
            surveyWmtsLayerKeysRef.current.add(key);
            pinSurveyWmtsBelowOverlays();
            applyPendingBringToTop(key, wmts);
            // Keep panel & map loading until the layer has painted.
            beginSurveyLayerMapRender(key, layer.name || key);
            void (async () => {
              try {
                await wmts.when?.();
                pinSurveyWmtsBelowOverlays();
                applyPendingBringToTop(key, wmts);
                try {
                  await waitForSurveyLayerViewReady(view, wmts);
                  pinSurveyWmtsBelowOverlays();
                  settleSurveyLayerPanelLoad(key, { ok: true });
                  applyPendingBringToTop(key, wmts);
                } finally {
                  endSurveyLayerMapRender(key);
                }
                if (geoserverLayerRefs.current[key] === wmts) {
                  flyToSurveyLayerIfOutOfView(view, wmts);
                }
              } catch (err: unknown) {
                settleSurveyLayerPanelLoad(key, {
                  ok: false,
                  message: err instanceof Error ? err.message : 'Layer failed to load',
                });
                endSurveyLayerMapRender(key);
              }
            })();
            return;
          }

          settleSurveyLayerPanelLoad(key, {
            ok: false,
            message: 'Unsupported survey layer type',
          });
          endSurveyLayerMapRender(key);
        } catch (err) {
          console.error('Failed to add Geoserver layer', key, err);
          settleSurveyLayerPanelLoad(key, {
            ok: false,
            message: err instanceof Error ? err.message : 'Layer failed to load',
          });
          endSurveyLayerMapRender(key);
        }
      } else {
        // remove
        if (pendingBringToTopLayerKeyRef.current === key) {
          pendingBringToTopLayerKeyRef.current = null;
        }
        settleSurveyLayerPanelLoad(key, { ok: true });
        endSurveyLayerMapRender(key);
        const existing = geoserverLayerRefs.current[key];
        if (existing) {
          try {
            stopMapViewAnimation(view);
            view.map.remove(existing);
          } catch (err) {
            console.warn('Failed to remove layer', key, err);
          }
          delete geoserverLayerRefs.current[key];
          surveyWmtsLayerKeysRef.current.delete(key);
        }
      }
    };

    window.addEventListener('attributes:toggle-layer', handleToggle as EventListener);

    return () => {
      window.removeEventListener('attributes:toggle-layer', handleToggle as EventListener);
      // cleanup remaining layers
      Object.values(geoserverLayerRefs.current).forEach((l) => {
        try {
          view.map.remove(l);
        } catch (e) { }
      });
      geoserverLayerRefs.current = {};
      surveyWmtsLayerKeysRef.current.clear();
      setSurveyLayerMapRenderingByKey(new Map());
    };
  }, [view]);

  const networkLayerState = layerRefreshLoading['network-layer'];
  const showNetworkLoadingOverlay =
    !hasNetworkLoadedOnce &&
    (networkLayerState?.isLoading || networkLayerState?.hasError);
  const surveyLayerMapRenderingNames = Array.from(surveyLayerMapRenderingByKey.values());
  const surveyLayerMapRendering = surveyLayerMapRenderingNames.length > 0;
  const surveyLayerMapRenderingMessage =
    surveyLayerMapRenderingNames.length === 1
      ? `Loading ${surveyLayerMapRenderingNames[0]}…`
      : surveyLayerMapRenderingNames.length > 1
        ? `Loading ${surveyLayerMapRenderingNames[0]} (+${surveyLayerMapRenderingNames.length - 1})…`
        : 'Loading layer…';
  const defectOverlayMapLoading =
    defectOverlayLoading.isFetching || defectOverviewLoading.isFetching;
  const defectOverlayVectorsHasError = defectOverlayLoading.hasError;
  const defectOverviewGridHasError = defectOverviewLoading.hasError;
  const defectOverlayHasError =
    defectOverlayVectorsHasError || defectOverviewGridHasError;
  const defectOverlayMapLoadingMessage = defectOverlayLoading.isFetching
    ? (defectOverlayLoading.message ?? 'Loading overlay…')
    : (defectOverviewLoading.message ?? 'Loading overlay grid…');
  const showMapLoadingOverlay =
    showNetworkLoadingOverlay ||
    defectOverlayMapLoading ||
    defectOverlayHasError ||
    surveyLayerMapRendering;

  return (
    <ImageViewerProvider mapView={view}>
    <div className={`dashboard-page${isPlaybackActive ? ' dashboard-page--playback' : ''}`}>
      {modalState['Major asset group overview'] && (
        <Charting
          isOpen={modalState['Major asset group overview']}
          closeModal={onCloseModal}
        />
      )}
      {modalState['Attributes'] && (
        <Attributes
          isOpen={modalState['Attributes']}
          data={attributesModalData}
          closeModal={onCloseAttributesModal}
          setIsExpanded={setSecondaryIsExpanded}
          isExpanded={primaryIsExpanded}
          rightSidebarRef={rightSidebarRef}
        />
      )}
      {surveyLayerPanelOpen && (
        <SurveyLayerPanelWithZIndex
          isOpen={surveyLayerPanelOpen}
          surveys={surveyLayerPanelSurveys}
          onClose={closeSurveyLayerPanel}
          onToggleLayer={toggleSurveyLayer}
          onRemoveSurvey={removeSurveyFromPanel}
          onSelectLayer={bringGeoserverLayerToTop}
          onZoomToExtent={zoomSurveyLayerToExtent}
          onGoToStart={handleSurveyLayerGoToStart}
          onHighlightSurvey={(surveySlug) => {
            void highlightSurveyOnMap(surveySlug, { flyToIfOutOfView: true });
          }}
          onHighlightSurveyOnMapOnly={(surveySlug) => {
            if (!pendingDragHighlightRestoreRef.current) {
              pendingDragHighlightRestoreRef.current = {
                mapSlug: highlightedMapSurveySlugRef.current,
                panelSlug: highlightedPanelSurveySlug,
              };
            }
            void highlightSurveyOnMap(surveySlug);
          }}
          onSurveyImageDragStart={handleSurveyImageDragStart}
          onSurveyImageDragEnd={handleSurveyImageDragEnd}
          onSurveyImageDragCancel={handleSurveyImageDragCancel}
          dropPinLandingApiRef={dropPinLandingApiRef}
          setLayerStyle={setSurveyLayerStyle}
          styles={layersStyle as unknown as SymbologyModelRecord}
          highlightedSurveySlug={highlightedPanelSurveySlug}
          activeSurveyPlaybackSlug={activeSurveySlug}
          playbackLoadingSurveySlug={playbackLoadingSurveySlug}
          isPlaybackGridOpen={isPlaybackActive}
          onPlaySurvey={handlePlaySurvey}
        />
      )}
      {layerSelectOpen && layerSelectData && (
        <LayerSelectModal
          isOpen={layerSelectOpen}
          surveyLabel={layerSelectData.surveyLabel}
          layers={layerSelectData.layers}
          onConfirm={(selectedKeys) => {
            setLayerSelectOpen(false);
            void triggerPlaybackStart(layerSelectData.surveySlug, selectedKeys);
          }}
          onCancel={() => setLayerSelectOpen(false)}
        />
      )}
      <NavBar
        displayModal={showModal}
        isExpanded={primaryIsExpanded}
        setIsExpanded={setPrimaryIsExpanded}
        toggleNavBarX={toggleNavBarX}
      />
      <div className="xa-map-container">
        {showMapLoadingOverlay && (
          <div
            className="dashboard-network-loading"
            role="status"
            aria-live="polite"
            aria-busy={
              (networkLayerState?.isLoading ?? false) ||
              defectOverlayMapLoading ||
              surveyLayerMapRendering
            }
          >
            {showNetworkLoadingOverlay && networkLayerState?.hasError ? (
              <div className="dashboard-network-loading__error">
                <strong>Unable to load Network</strong>
                {/* <p>
                  {networkLayerState.errorMessage ||
                    'The network layer could not be loaded. Try refreshing from the legend.'}
                </p> */}
              </div>
            ) : defectOverlayVectorsHasError ? (
              <div className="dashboard-network-loading__error">
                <strong>
                  {defectOverlayLoading.errorMessage ?? 'Unable to load overlay'}
                </strong>
              </div>
            ) : defectOverviewGridHasError ? (
              <div className="dashboard-network-loading__error">
                <strong>
                  {defectOverviewLoading.errorMessage ??
                    'Unable to load overlay grid'}
                </strong>
              </div>
            ) : showNetworkLoadingOverlay ? (
              <Loader cover overlay={false} message="Loading Network…" />
            ) : surveyLayerMapRendering ? (
              <Loader
                cover
                overlay={false}
                message={surveyLayerMapRenderingMessage}
              />
            ) : (
              <Loader
                cover
                overlay={false}
                message={defectOverlayMapLoadingMessage}
              />
            )}
          </div>
        )}
        <MapView setView={setView} setBaseLayer={setBaseLayer} />
      </div>
      <ToolBar
        onAction={onAction}
        activeActions={actionsState}
        isExpanded={secondaryIsExpanded}
        setIsExpanded={setSecondaryIsExpanded}
        currentLayer={currentLayer}
        onLayerChange={onLayerChange}
        onNodeChecked={onNodeChecked}
        onNodeCheckedSurveyManager={onNodeCheckedSurveyManager}
        setLayerStyle={setLayerStyle}
        setLayerVisualisationRules={setLayerVisualisationRules}
        bringLayerToTop={bringLayerToTop}
        zoomToSection={zoomToSection}
        layersStyle={layersStyle as unknown as SymbologyModelRecord}
        layerRulesStyles={layerRulesStyles}
        zoomStackIsAllowed={zoomStackIsAllowed}
        setCheckedNodesState={(nodes) => {
          setCheckedNodesState(nodes as LayerListNode[]);
        }}
        handleContextMenuRefreshClicked={handleContextMenuRefreshClicked}
        checkedNodesState={checkedNodesState}
        layerRefreshLoading={layerRefreshLoading}
        setLayerRefreshLoading={setLayerRefreshLoading}
        rightSidebarRef={rightSidebarRef}
        showDirection={showDirection}
        setShowDirection={setShowDirection}
        exportToShapefile={exportToShapefile}
        isExporting={isExporting}
        cancelShapefileExport={cancelShapefileExport}
        exportProgress={exportProgress}
        onSurveyLayerTypesLoaded={setSurveyLayerTypes}
        emapsiteBasemapsEnabled={emapsiteBasemapsEnabled}
        layerData={layerData}
      />
      {!isPlaybackActive && (
        <SearchContainer
          isNodeSelected={isNodeSelected}
          searchContentData={searchContent}
          onSelectSearchDetailsItem={onSelectSearchDetailsItem}
          onSelectSearchDetailsType={onSelectSearchDetailsType}
          searchCurrentLayer={searchCurrentLayer}
          onSearchResultsChange={handleSearchResultsChange}
          tenantName={tenant}
        />
      )}
      <UserContainer
        email={user.email}
        firstname={user.firstname}
        surname={user.surname}
      />
      <ImageViewerModals
        playback={
          isPlaybackActive
            ? {
                layerCount: playbackLayers.length,
                title:
                  playbackLayers[0]?.surveyLabel != null
                    ? `Playback · ${playbackLayers[0].surveyLabel} (${playbackLayers.length})`
                    : `Survey playback (${playbackLayers.length})`,
                onStop: handleStopPlayback,
                showDownloadAll: playbackLayers.length > 1,
                canDownloadAll: playbackCanDownloadAll,
                onDownloadAll: handlePlaybackDownloadAll,
                children: (
                  <PlaybackGrid
                    layers={playbackLayers}
                    isLoading={isPlaybackGridLoading}
                    currentIndex={playbackIndex}
                    syncMode={playbackSyncMode}
                    focusOwnerLayerKey={playbackFocusOwnerLayerKey}
                    focusMessage={playbackFocusMessage}
                    currentSyncValue={currentPlaybackSyncValue}
                    maxIndex={playbackMaxIndex}
                    onNavigate={handlePlaybackNavigate}
                    onSetSyncModeFromFeature={handlePlaybackSetSyncModeFromFeature}
                    onPanoramaStateChange={handlePlaybackPanoramaStateChange}
                    onDownloadAllControlsChange={
                      handlePlaybackDownloadAllControlsChange
                    }
                  />
                ),
              }
            : null
        }
      />
    </div>
    </ImageViewerProvider>
  );
}

/** Central multi-image workspace for WFS survey clicks and playback. */
function ImageViewerModals({
  playback,
}: {
  readonly playback: React.ComponentProps<typeof MultiImageViewer>['playback'];
}) {
  return <MultiImageViewer playback={playback} />;
}

/** Thin wrapper that gives SurveyLayerPanel access to the shared z-index counter. */
function SurveyLayerPanelWithZIndex(props: React.ComponentProps<typeof SurveyLayerPanel>) {
  const { getNextZIndex } = useImageViewers();
  const [zIndex, setZIndex] = React.useState(() => getNextZIndex());

  React.useEffect(() => {
    const onMouseDown = (e: MouseEvent) => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('.slp-panel')) return;
      setZIndex(getNextZIndex());
    };
    document.addEventListener('mousedown', onMouseDown, true);
    return () => document.removeEventListener('mousedown', onMouseDown, true);
  }, [getNextZIndex]);

  return <SurveyLayerPanel {...props} zIndex={zIndex} />;
}

export default Dashboard;
